import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_CaAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_CaAssessment' className='file-pdf-document'>
            <div className='file-template'>
        <p className="w-750">
          <strong>INSURANCE INFORMATION</strong>
        </p>
        <table>
          <tr>
            <td className="w-750">
              <span className="eleHeader">Insurance Type</span>
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_1"
                name="cbInsuranceType_1"
                className="add-only"
                value="InsuranceType_1"
              />
              Medicaid Standard:
              <input
                type="text"
                id="txtMedicaid1"
                name="txtMedicaid1"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_2"
                name="cbInsuranceType_2"
                className="add-only"
                value="InsuranceType_2"
              />
              Cenpatico::
              <input
                type="text"
                id="txtMedicaid2"
                name="txtMedicaid2"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_3"
                name="cbInsuranceType_3"
                className="add-only"
                value="InsuranceType_3"
              />
              Amerigroup:
              <input
                type="text"
                id="txtMedicaid3"
                name="txtMedicaid3"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_4"
                name="cbInsuranceType_4"
                className="add-only"
                value="InsuranceType_4"
              />
               Ambetter:
              <input
                type="text"
                id="txtMedicaid4"
                name="txtMedicaid4"
                className="add-only"
              />
            </td>
          </tr>

          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_5"
                name="cbInsuranceType_5"
                className="add-only"
                value="InsuranceType_5"
              />
              Caresource:
              <input
                type="text"
                id="txtMedicaid5"
                name="txtMedicaid5"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_6"
                name="cbInsuranceType_6"
                className="add-only"
                value="InsuranceType_6"
              />
              Other:
              <input
                type="text"
                id="txtMedicaid6"
                name="txtMedicaid6"
                className="add-only"
              />
            </td>
          </tr>
        </table>
        <h3>A. INDIVIDUAL PRESENTATION & PRESENTING PROBLEM</h3>
        <p className="w-750">
          <span className="eleHeader">Location of assessment?</span>
          <textarea
            id="txtLocationAssessment"
            name="txtLocationAssessment"
            className="add-only"
          ></textarea>
        </p>
        <p className="w-750">
          <span className="eleHeader">Who was present during assessment?</span>
          <textarea
            id="txtPresentAssessment"
            name="txtPresentAssessment"
            className="add-only"
          ></textarea>
        </p>
         <h3>B.  MENTAL STATUS EXAM<span className='small'>(Check all that apply)</span></h3>
                <p className='w-750'>
                    <span className='eleHeader'>General Appearance</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_1" name="cbGeneralAppearance_1" className='add-only' value="GeneralAppearance_1" />Overweight
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_2" name="cbGeneralAppearance_2" className='add-only' value="GeneralAppearance_2" />Frail
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_3" name="cbGeneralAppearance_3" className='add-only' value="GeneralAppearance_3" />Lean
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_4" name="cbGeneralAppearance_4" className='add-only' value="GeneralAppearance_4" />Muscular
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_5" name="cbGeneralAppearance_5" className='add-only' value="GeneralAppearance_5" />Neat
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Behavior</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_1" name="cbBehavior_1" className='add-only' value="Behavior_1" />Older than age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_2" name="cbBehavior_2" className='add-only' value="Behavior_2" />Younger than age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_3" name="cbBehavior_3" className='add-only' value="Behavior_3" />Sloppy
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_4" name="cbBehavior_4" className='add-only' value="Behavior_4" />Slumped
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_5" name="cbBehavior_5" className='add-only' value="Behavior_5" />Cooperative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_6" name="cbBehavior_6" className='add-only' value="Behavior_6" />Open
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_7" name="cbBehavior_7" className='add-only' value="Behavior_7" />Irritable
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_8" name="cbBehavior_8" className='add-only' value="Behavior_8" />Anxious
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_9" name="cbBehavior_9" className='add-only' value="Behavior_9" />Calm
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_10" name="cbBehavior_10" className='add-only' value="Behavior_10" />Combative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_11" name="cbBehavior_11" className='add-only' value="Behavior_11" />Agitated
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_12" name="cbBehavior_12" className='add-only' value="Behavior_12" />Defensive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbBehavior_13" name="cbBehavior_13" className='add-only' value="Behavior_13" />Other :
                            <input type="text" id="txtBehavior_13" name="txtBehavior_13" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>If risk exists, Individual is able to contract not to harm:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-75'><input type="radio" id="rbSuicidalIdeation1_Yes" name="rbSuicidalIdeation1" className='add-only' value="Yes" /> Self &nbsp;</td>
                        <td className='w-75'><input type="radio" id="rbSuicidalIdeation1_No" name="rbSuicidalIdeation1" className='add-only' value="No" /> Others</td>
                        <td className='w-600'><input type="text" id="txtServiceParticipantsOthers" name="txtServiceParticipantsOthers" className='add-only' /></td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Mood/Affect</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Mood_1" />Appropriate
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Mood_2" />Apathetic
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Mood_3" />Euphoric
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Mood_4" />Angry
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Mood_5" />Flat
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Mood_6" />Hostile
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_7" name="cbMood_7" className='add-only' value="Mood_7" />Sad
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_8" name="cbMood_8" className='add-only' value="Mood_8" />Tearful
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMood_9" name="cbMood_9" className='add-only' value="Mood_9" />Other :
                            <input type="text" id="txtMood_9" name="txtMood_9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Speech</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Speech_1" />Normal Limits
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Speech_2" />Rapid
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Speech_3" />Stuttering
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Speech_4" />Slurred
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Speech_5" />Soft
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Speech_6" />Pressured
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="Speech_7" />Other :
                            <input type="text" id="txtSpeech_7" name="txtSpeech_7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Thought Process</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_1" name="cbThoughtProcess_1" className='add-only' value="ThoughtProcess_1" />Logical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_2" name="cbThoughtProcess_2" className='add-only' value="ThoughtProcess_2" />Grandiose
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_3" name="cbThoughtProcess_3" className='add-only' value="ThoughtProcess_3" />Paranoid
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_4" name="cbThoughtProcess_4" className='add-only' value="ThoughtProcess_4" />Unorganized
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_5" name="cbThoughtProcess_5" className='add-only' value="ThoughtProcess_5" />Loose
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_6" name="cbThoughtProcess_6" className='add-only' value="ThoughtProcess_6" />Delusional
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_7" name="cbThoughtProcess_7" className='add-only' value="ThoughtProcess_7" />Tangential
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbThoughtProcess_8" name="cbThoughtProcess_8" className='add-only' value="ThoughtProcess_8" />Other :
                            <input type="text" id="txtThoughtProcess_8" name="txtThoughtProcess_8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Perception</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_1" name="cbPerception_1" className='add-only' value="Perception_1" />Normal Limits
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_2" name="cbPerception_2" className='add-only' value="Perception_2" />Auditory Hallucinations
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_3" name="cbPerception_3" className='add-only' value="Perception_3" />Visual Hallucinations
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_4" name="cbPerception_4" className='add-only' value="Perception_4" />Tactile Hallucinations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPerception_5" name="cbPerception_5" className='add-only' value="Perception_5" />Other :
                            <input type="text" id="txtPerception_5" name="txtPerception_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Orientation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Orientation_1" />To person
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Orientation_2" />To place
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Orientation_3" />To situation
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Orientation_4" />To time
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_5" name="cbOrientation_5" className='add-only' value="Orientation_5" />Disoriented
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Memory</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_1" name="cbMemory_1" className='add-only' value="Memory_1" />Recent intact (Can repeat 3 digits)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_2" name="cbMemory_2" className='add-only' value="Memory_2" />Remote intact (can provide history)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_3" name="cbMemory_3" className='add-only' value="Memory_3" />Recent not intact
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_4" name="cbMemory_4" className='add-only' value="Memory_4" />Remote not intact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemory_5" name="cbMemory_5" className='add-only' value="Memory_5" />Other :
                            <input type="text" id="txtMemory_5" name="txtMemory_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Insight into illness/life situation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="Insight_1" />Unimpaired
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Insight_2" />Limited
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Insight_3" />Absent
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbInsight_4" name="cbInsight_4" className='add-only' value="Insight_4" />Other :
                            <input type="text" id="txtInsight_4" name="txtInsight_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Suicidal Ideation:</span></td>
                        <td className='w-375'><span className='eleHeader'>Homicidal Ideation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                           <input type="radio" id="rbSuicidalIdeation_Yes" name="rbSuicidalIdeation" className='add-only' value="Yes" /> Yes &nbsp;
                           <input type="radio" id="rbSuicidalIdeation_No" name="rbSuicidalIdeation" className='add-only' value="No" /> No
                        </td>
                  
                        <td className='w-375'>
                          <input type="radio" id="rbHomicidalIdeations_Yes" name="rbHomicidalIdeations" className='add-only' value="Yes" /> Yes &nbsp;
                          <input type="radio" id="rbHomicidalIdeations_No" name="rbHomicidalIdeations" className='add-only' value="No" /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>If yes:  Suicide Plan</span></td>
                        <td className='w-375'><span className='eleHeader'>If yes:  Homicide Plan</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                           <input type="radio" id="rbYes_SuicidalIdeation_Yes" name="rbYes_SuicidalIdeation" className='add-only' value="Yes" /> Yes &nbsp;
                           <input type="radio" id="rbYes_SuicidalIdeation_No" name="rbYes_SuicidalIdeation" className='add-only' value="No" /> No
                        </td>
                  
                        <td className='w-375'>
                          <input type="radio" id="rbYes_HomicidalIdeations_Yes" name="rbYes_HomicidalIdeations" className='add-only' value="Yes" /> Yes &nbsp;
                          <input type="radio" id="rbYes_HomicidalIdeations_No" name="rbYes_HomicidalIdeations" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Mental Status:</span>
                    <span className='small'>(Describe Individual's mood, affect, thought processes, though contact, AVH, intelligence, insight, judgment, and orientation)</span>
                    <textarea id="txtMentalStatus" name="txtMentalStatus" className='add-only'></textarea>
                </p>
                <h3>C. PRESENTING PROBLEM AND REQUESTED SERVICE</h3>
                <p className="w-750">
                    <span className='eleHeader'>What is the Individual's presenting problem / Diagnostic Criteria:</span>
                    <span className='small'>
                        This should be in the Individual's own words as well as Assessor's description of Clinical Criteria met for DSM-5 dx per Individual's input: 
                    </span>
                    <textarea id="txtIndividualPresentingProblem" name="txtIndividualPresentingProblem" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What is the parent's/family's perception of the problem?</span>
                    <textarea id="txtPresentingfamilyProblem" name="txtPresentingfamilyProblem" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>Origin of problem/when it began:</span>
                    <span className='small'>Include the onset of the problem, duration, frequency, past intervention/services and the results of the services.</span>
                    <textarea id="txtOriginProblem" name="txtOriginProblem" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>Related Issues that exacerbate the problem:</span>
                    <textarea id="txtRelatedIssues" name="txtRelatedIssues" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What services is the parent/family asking for?:</span>
                    <textarea id="txtPresentingfamilyAsking" name="txtPresentingfamilyAsking" className='add-only'></textarea>
                </p>
                <h3>D. MEDICAL AND BEHAVIORAL HEALTH HISTORY</h3>
                <p className="w-750">
                    List all major illness, surgeries, major injuries. Begin with most recent and work backwards
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Past Conditions </span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Onset </span></td>
                        <td className='w-250'><span className='eleHeader'>Residual Effects </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_1" name="txtPast_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_1" name="txtDateOf_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_1" name="txtResidual_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_2" name="txtPast_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_2" name="txtDateOf_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_2" name="txtResidual_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>E. MEDICAL ASSESSMENT</h3>
                <p className="w-750">
                    <span className='eleHeader'>What medical problems does the Individual have? </span>
                    <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)</span>
                    <textarea id="txtmedicalproblems" name="txtmedicalproblems" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What was the Individual's prenatal history? Health at birth? Early development? </span>
                    <span className='small'>(Include any delays with walking, crawling, sitting up, concerns with height/weight, any problems with running, jumping, climbing, balancing, coordination, problems with hearing, vision or speech; current with immunizations)</span>
                    <textarea id="txtIndividualprenatalhistory" name="txtIndividualprenatalhistory" className='add-only'></textarea>
                </p>
                <h3>PRESCRIBED MEDICATIONS </h3>
                <p className="w-750">
                    <span className='small'>(Include both medical and psychiatric medications)</span>
                    <input type="checkbox" id="cbNone_1" name="cbNone_1" className='add-only' value="None" /><strong>None</strong> 
                </p>
                <table>
                    <tr>
                        <td className='w-125'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-125'><span className='eleHeader'>Dose/Frequency</span> </td>
                        <td className='w-125'><span className='eleHeader'>Prescribed by?</span></td>
                        <td className='w-150'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-125'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-100'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName1_1" name="txtMedicationName1_1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency1_1" name="txtDose_Frequency1_1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy1_1" name="txtPrescribedBy1_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed1_1" name="txtWhenPrescribed1_1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill1_1" name="txtrefill1_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects1_1" name="txtSideEffects1_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName1_2" name="txtMedicationName1_2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency1_2" name="txtDose_Frequency1_2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy1_2" name="txtPrescribedBy1_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed1_2" name="txtWhenPrescribed1_2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill1_2" name="txtrefill1_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects1_2" name="txtSideEffects1_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Is Individual compliant with medications?</span>
                    <input type="radio" id="rbSuicidalIdeation1_Yes" name="rbSuicidalIdeation1" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbSuicidalIdeation1_No" name="rbSuicidalIdeation1" className='add-only' value="No" />No, explain:
                    <input type="text" id="txtcompliantmedications1" name="txtcompliantmedications1" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Primary Care Physician:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone No.</span> </td>
                    </tr>
                    <tr>
                    <td className='w-375'>
                            <input type="text" id="txtPrimaryPhysician" name="txtPrimaryPhysician" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtTelephone_1" name="txtTelephone_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Psychiatrist:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone No.</span> </td>
                    </tr>
                    <tr>
                    <td className='w-375'>
                            <input type="text" id="txtCPsychiatrist" name="txtPrimaryPhysician" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtTelephone_2" name="txtTelephone_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of last PCP Visit: </span></td>
                        <td className='w-375'><span className='eleHeader'>Date of last Dental Visit: </span> </td>
                    </tr>
                    <tr>
                    <td className='w-375'>
                            <input type="date" id="dtPCPVisit" name="dtPCPVisit" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="dtDentalVisit" name="dtDentalVisit" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Date of last Vision Exam:  </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="date" id="dtVisionExam" name="dtVisionExam" className='add-only' />
                        </td>
                    </tr> 
                </table>
                <h3>F.	PAIN ASSESSMENT</h3>
                <p className="w-750">
                    <span className='eleHeader'>What medical problems does the Individual have? </span>
                    <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)</span>
                    <input type="checkbox" id="cbPAINASSESSMENT_None" name="cbPAINASSESSMENT_None" className='add-only' value="PAINASSESSMENT_None" /><strong>None</strong>
                    <textarea id="txtPAIN" name="txtPAIN" className='add-only'></textarea>
                </p>
                <table>
                   <tr>
                        <td className='w-125'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-125'><span className='eleHeader'>Dose/Frequency</span> </td>
                        <td className='w-125'><span className='eleHeader'>Prescribed by?</span></td>
                        <td className='w-150'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-125'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-100'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_1" name="txtMedicationName2_1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_1" name="txtDose_Frequency2_1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_1" name="txtPrescribedBy2_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_1" name="txtWhenPrescribed2_1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_1" name="txtrefill2_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_1" name="txtSideEffects2_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_2" name="txtMedicationName2_2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_2" name="txtDose_Frequency2_2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_2" name="txtPrescribedBy2_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_2" name="txtWhenPrescribed2_2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_2" name="txtrefill2_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_2" name="txtSideEffects2_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_3" name="txtMedicationName2_3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_3" name="txtDose_Frequency2_3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_3" name="txtPrescribedBy2_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_3" name="txtWhenPrescribed2_3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_3" name="txtrefill2_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_3" name="txtSideEffects2_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_4" name="txtMedicationName2_4" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_4" name="txtDose_Frequency2_4" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_4" name="txtPrescribedBy2_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_4" name="txtWhenPrescribed2_4" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_4" name="txtrefill2_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_4" name="txtSideEffects2_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_5" name="txtMedicationName2_5" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_5" name="txtDose_Frequency2_5" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_5" name="txtPrescribedBy2_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_5" name="txtWhenPrescribed2_5" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_5" name="txtrefill2_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_5" name="txtSideEffects2_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_6" name="txtMedicationName2_6" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_6" name="txtDose_Frequency2_6" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_6" name="txtPrescribedBy2_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_6" name="txtWhenPrescribed2_6" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_6" name="txtrefill2_6" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_6" name="txtSideEffects2_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_7" name="txtMedicationName2_7" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_7" name="txtDose_Frequency2_7" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_7" name="txtPrescribedBy2_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_7" name="txtWhenPrescribed2_7" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_7" name="txtrefill2_7" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_7" name="txtSideEffects2_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_8" name="txtMedicationName2_8" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_8" name="txtDose_Frequency2_8" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_8" name="txtPrescribedBy2_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_8" name="txtWhenPrescribed2_8" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_8" name="txtrefill2_8" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_8" name="txtSideEffects2_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_9" name="txtMedicationName2_9" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_9" name="txtDose_Frequency2_9" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_9" name="txtPrescribedBy2_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_9" name="txtWhenPrescribed2_9" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_9" name="txtrefill2_9" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_9" name="txtSideEffects2_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                       <td className='w-125'>
                            <input type="text" id="txtMedicationName2_10" name="txtMedicationName2_10" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtDose_Frequency2_10" name="txtDose_Frequency2_10" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPrescribedBy2_10" name="txtPrescribedBy2_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhenPrescribed2_10" name="txtWhenPrescribed2_10" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtrefill2_10" name="txtrefill2_10" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects2_10" name="txtSideEffects2_10" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Is Individual compliant with medications?</span>
                    <input type="radio" id="rbSuicidalIdeation2_Yes" name="rbSuicidalIdeation2" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbSuicidalIdeation2_No" name="rbSuicidalIdeation2" className='add-only' value="No" />No, explain:
                    <input type="text" id="txtcompliantmedications2" name="txtcompliantmedications2" className='add-only' />
                </p>
                <table>
                <tr>
                    <td className='w-375'><span className='eleHeader'>Current Physician Prescribing Medication(s) for Pain:</span></td>
                    <td className='w-375'><span className='eleHeader'>Telephone No.</span> </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="text" id="txtPrescribingMedication" name="txtPrescribingMedication" className='add-only' />
                    </td>
                    <td className='w-375'>
                        <input type="text" id="txtPrescribingMedication_Telephone" name="txtPrescribingMedication_Telephone" className='add-only' />
                    </td>
                </tr>
                </table>
                <h3>NUTRITIONAL SCREENING</h3>
                <h4>Nutritional Status</h4>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Weight:</span></td>
                        <td className='w-375'><span className='eleHeader'>Current Height:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtWeight" name="txtWeight" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtHeight" name="txtHeight" className='add-only' />
                        </td>
                    </tr>
                </table>
                
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appetite</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_1" name="cbAppetite_1" className='add-only' value="Appetite_1" />Good
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_2" name="cbAppetite_2" className='add-only' value="Appetite_2" />Fair
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_3" name="cbAppetite_3" className='add-only' value="Appetite_3" />Poor,explain below
                            <input type="text" id="txtExplainBelowAppetite_3" name="txtExplainBelowAppetite_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eating Behavior</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEatingBehavior_1" name="cbEatingBehavior_1" className='add-only' value="EatingBehavior_1" />Binges/overeats to excess
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEatingBehavior_2" name="cbEatingBehavior_2" className='add-only' value="EatingBehavior_2" />Hiding/Hording food
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEatingBehavior_3" name="cbEatingBehavior_3" className='add-only' value="EatingBehavior_3" />Restricts food/vomits/over-exercises to avoid weight gain
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_1" name="cbOther_1" className='add-only' value="Other_1" />Recently gained/lost significant weight
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_2" name="cbOther_2" className='add-only' value="Other_2" />Special Dietary Needs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_3" name="cbOther_3" className='add-only' value="Other_3" />Allergies, explain below
                            <input type="text" id="txtExplainBelowOther_3" name="txtExplainBelowOther_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>HIV Prevention Education information offered</span>
                    <input type="radio" id="rbHivPreventionAccepted_Yes" name="rbHivPreventionAcceptedDeclined" className='add-only' value="1" /> Accepted &nbsp;
                    <input type="radio" id="rbHivPreventionDeclined_No" name="rbHivPreventionAcceptedDeclined" className='add-only' value="0" /> Declined
                </p>
                <p className="w-750">
                    <span className='eleHeader'>HIV Testing referral offered</span>
                    <input type="radio" id="rbHivTestingAccepted_Yes" name="rbHivTestingAcceptedDeclined" className='add-only' value="1" /> Accepted &nbsp;
                    <input type="radio" id="rbHivTestingDeclined_No" name="rbHivTestingAcceptedDeclined" className='add-only' value="0" /> Declined
                </p>
                <p className="w-750">
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtHivComments" name="txtHivComments" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>ASSISTIVE TECHNOLOGY OR ADAPTIVE DEVICES</span>
                </p>
                <table>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_Deaf" name="cbAssistiveTechnology_Deaf" className='add-only' value="AssistiveTechnology_Deaf" />Deaf 
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_Blind" name="cbAssistiveTechnology_Blind" className='add-only' value="AssistiveTechnology_Blind" />Blind
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_1" name="cbAssistiveTechnology_1" className='add-only' value="AssistiveTechnology_1" />None
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_2" name="cbAssistiveTechnology_2" className='add-only' value="AssistiveTechnology_2" />Glasses
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_3" name="cbAssistiveTechnology_3" className='add-only' value="AssistiveTechnology_3" />Walker
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_4" name="cbAssistiveTechnology_4" className='add-only' value="AssistiveTechnology_4" />Braille
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_5" name="cbAssistiveTechnology_5" className='add-only' value="AssistiveTechnology_5" />Hearing Aids
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_6" name="cbAssistiveTechnology_6" className='add-only' value="AssistiveTechnology_6" />Cane
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_7" name="cbAssistiveTechnology_7" className='add-only' value="AssistiveTechnology_7" />Crutches
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_8" name="cbAssistiveTechnology_8" className='add-only' value="AssistiveTechnology_8" />Wheelchair
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_9" name="cbAssistiveTechnology_9" className='add-only' value="AssistiveTechnology_9" />Translated Written 
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAssistiveTechnology_10" name="cbAssistiveTechnology_10" className='add-only' value="AssistiveTechnology_10" />Translator for Speaking
                    </td>
                    <td colSpan={2}>
                        <input type="checkbox" id="cbAssistiveTechnology_11" name="cbAssistiveTechnology_11" className='add-only' value="AssistiveTechnology_11" />Other Information
                        <input type="text" id="txtAssistiveTechnology_11" name="txtAssistiveTechnology_11" className='add-only' />
                    </td>
                </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>If any of the above were checked, please provide details below.</span> <span className='small'>(list allergies)</span>
                    <textarea id="txtAssistiveTechnology" name="txtAssistiveTechnology" className='add-only'></textarea>
                </p>
                <h3>G.	FAMILY MEDICAL HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Type of Illness</span></td>
                        <td className='w-75'><span className='eleHeader'>Yes</span></td>
                        <td className='w-75'><span className='eleHeader'>No</span></td>
                        <td className='w-350'><span className='eleHeader'>Relationship (Father, Mother, Sibling, Aunt, Uncle, etc...)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cardiovascular</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_1" name="rbIllness_1" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_1" name="rbIllness_1" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_1" name="txtRelationship_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Hypertension</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_2" name="rbIllness_2" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_2" name="rbIllness_2" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_2" name="txtRelationship_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Seizures</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_3" name="rbIllness_3" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_3" name="rbIllness_3" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_3" name="txtRelationship_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Psychiatric Hospitalization</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_4" name="rbIllness_4" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_4" name="rbIllness_4" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_4" name="txtRelationship_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Suicide</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_5" name="rbIllness_5" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_5" name="rbIllness_5" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_5" name="txtRelationship_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Depression</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_6" name="rbIllness_6" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_6" name="rbIllness_6" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_6" name="txtRelationship_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Addictions</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_7" name="rbIllness_7" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_7" name="rbIllness_7" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_7" name="txtRelationship_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Eating Disorder</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_8" name="rbIllness_8" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_8" name="rbIllness_8" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_8" name="txtRelationship_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cancer</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_9" name="rbIllness_9" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_9" name="rbIllness_9" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_9" name="txtRelationship_9" className='add-only' />
                        </td>
                    </tr>
                     <tr>
                        <td className='w-250'>Other:</td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessYes_10" name="rbIllness_10" className='add-only' value="1" />
                        </td>
                        <td className='w-75'>
                            <input type="radio" id="rbIllnessNo_10" name="rbIllness_10" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtRelationship_10" name="txtRelationship_10" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>H. BEHAVIOR AND MENTAL HEALTH ASSESSMENT</h3>
                <p>
                    Please complete the below checklist for symptoms:
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Key:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>Severity Rating:</strong></td>
                        <td className='w-375'><strong>Duration Rating:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>1=</strong></td>
                        <td className='w-325'>Mild </td>
                        <td className='w-50'><strong>1=</strong></td>
                        <td className='w-325'>Less than 1 Month</td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>2=</strong></td>
                        <td className='w-325'>Moderate </td>
                        <td className='w-50'><strong>2=</strong></td>
                        <td className='w-325'>1 to 6 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>3=</strong></td>
                        <td className='w-325'>Severe </td>
                        <td className='w-50'><strong>3=</strong></td>
                        <td className='w-325'>7 to 11 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'></td>
                        <td className='w-325'></td>
                        <td className='w-50'><strong>4=</strong></td>
                        <td className='w-325'>More than 1 Year</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Symptom/Problem</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                        <td className='w-150'><span className='eleHeader'>Duration</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>1.	Anxiety</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_1" name="txtSeverity_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_1" name="txtDuration_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>2.	Appetite Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_2" name="txtSeverity_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_2" name="txtDuration_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>3.	Bizarre Behavior</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_3" name="txtSeverity_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_3" name="txtDuration_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>4.	Bizarre Ideations (Delusions)</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_4" name="txtSeverity_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_4" name="txtDuration_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>5.	Conduct Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_5" name="txtSeverity_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_5" name="txtDuration_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>6.	Depression</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_6" name="txtSeverity_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_6" name="txtDuration_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>7.	Eating Disorder</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_7" name="txtSeverity_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_7" name="txtDuration_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>8.	Family Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_8" name="txtSeverity_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_8" name="txtDuration_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>9.	Gender Issues</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_9" name="txtSeverity_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_9" name="txtDuration_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>10.	Impaired Memory</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_10" name="txtSeverity_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_10" name="txtDuration_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>11.	Indep. Living Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_11" name="txtSeverity_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_11" name="txtDuration_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>12.	Lack of Support System</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_12" name="txtSeverity_12" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_12" name="txtDuration_12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>13.	Loss of Energy</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_13" name="txtSeverity_13" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_13" name="txtDuration_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>14.	Loss of Interest</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_14" name="txtSeverity_14" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_14" name="txtDuration_14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>15.	Obsessive/Compulsive</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_15" name="txtSeverity_15" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_15" name="txtDuration_15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>16.	Panic Attacks</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_16" name="txtSeverity_16" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_16" name="txtDuration_16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>17.	Paranoid Ideation</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_17" name="txtSeverity_17" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_17" name="txtDuration_17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>18.	Phobia</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_18" name="txtSeverity_18" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_18" name="txtDuration_18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>19.	Poor Interpersonal Skills</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_19" name="txtSeverity_19" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_19" name="txtDuration_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>20.	Poor Judgment</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_20" name="txtSeverity_20" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_20" name="txtDuration_20" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>21. Poor Self Care Skills</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_21" name="txtSeverity_21" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_21" name="txtDuration_21" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>22. School Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_22" name="txtSeverity_22" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_22" name="txtDuration_22" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>23. Sexual Acting Out</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_23" name="txtSeverity_23" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_23" name="txtDuration_23" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>24. Sleep Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_24" name="txtSeverity_24" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_24" name="txtDuration_24" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>25. Somatization</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_25" name="txtSeverity_25" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_25" name="txtDuration_25" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>26. Unusual Body Movements</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_26" name="txtSeverity_26" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_26" name="txtDuration_26" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>27. Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_27" name="txtSeverity_27" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_27" name="txtDuration_27" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>If any of the above were checked, please provide specific details below. Please indicate frequency and intensity of symptoms.</span>
                    <textarea id="txtAssistiv" name="txtAssistiv" className='add-only'></textarea>
                </p>
            <h3>Has Individual ever been treated for a mental health problem? </h3>
                <p className="w-750">
                  <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions, and outcome)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Date (s)</span></td>
                        <td className='w-150'><span className='eleHeader'>Location</span></td>
                        <td className='w-150'><span className='eleHeader'>Type of Treatment </span><span className='small'>(Outpatient, Inpatient, etc)</span></td>
                        <td className='w-150'><span className='eleHeader'>Diagnosis Given</span></td>
                        <td className='w-150'><span className='eleHeader'>Outcome </span><span className='small'>(i.e., stabilized, withdrew from services, etc.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_1" name="txtDate_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_1" name="txtLocation_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_1" name="txtTreatment_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_1" name="txtDiagnosis_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_1" name="txtOutcome_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_2" name="txtDate_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_2" name="txtLocation_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_2" name="txtTreatment_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_2" name="txtDiagnosis_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_2" name="txtOutcome_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_3" name="txtDate_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_3" name="txtLocation_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_3" name="txtTreatment_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_3" name="txtDiagnosis_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_3" name="txtOutcome_3" className='add-only' />
                        </td>
                    </tr>
                </table>
        <h3>I. COLUMBIA-SUICIDE SEVERITY RATING SCALE</h3>
        <p className="w-750"><span className="small">(Screen Version) <br /><strong>Pls answer -LIFETIME (During Initial Ax) <br />
           Pls answer-  RECENT/Last 30 days  (During Re-Ax/Update)
          </strong></span>
        </p>
<table>  
  <tr>
    <td className="w-600" >
      SUICIDE IDEATION DEFINITIONS AND PROMPTS:
    </td>
    <td className="w-150"><input type="checkbox" id="cbRe_Ax_PastMonth" name="cbRe_Ax_PastMonth" className='add-only' value="Re_Ax_PastMonth" />Re-Ax- Past Month <br />
    <input type="checkbox" id="cbINITIAL_LIFETIME" name="cbINITIAL_LIFETIME" className='add-only' value="INITIAL_LIFETIME" />INITIAL - LIFETIME </td> 
  </tr>

  <tr>
    <td className="w-600">
      <span className="eleHeader">
        Ask questions that are bolded and underlined.
      </span>
    </td>
    <td className="w-75">
      <span className="eleHeader">Yes</span>
    </td>
    <td className="w-75">
      <span className="eleHeader">No</span>
    </td>
  </tr>

  <tr>
    <td>
      <h2>Ask Questions 1 and 2 :</h2>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <strong> 1) Wish to be Dead: </strong>
      <span className="small">
        Person endorses thoughts about a wish to be dead or not alive
        anymore, or wish to fall asleep and not wake up.
      </span>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <u>
        <strong>
          Have you wished you were dead or wished you could go to sleep
          and not wake up?{" "}
        </strong>
      </u>{" "}
    </td>
    <td className="w-20"></td>
    <td className="w-60">
      {" "}
      <input
        type="radio"
        id="rb_Wish_Dead_yes"
        name="Wish_Dead"
        className="add-only"
        value="Yes"
      />
    </td>
    <td className="w-60">
      <input
        type="radio"
        id="rb_Wish_Dead_No"
        name="Wish_Dead"
        className="add-only"
        value="No"
      />
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <strong> 2) Suicidal Thoughts: </strong>
      <span className="small">
        General non-specific thoughts of wanting to end one's
        life/commit suicide, “I've thought about killing myself” without
        general thoughts of ways to kill oneself/associated methods,
        intent, or plan.”
      </span>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <u>
        <strong>
          Have you actually had any thoughts of killing yourself?{" "}
        </strong>
      </u>{" "}
    </td>
    <td className="w-20"></td>
    <td className="w-60">
      {" "}
      <input
        type="radio"
        id="rb_Suicidal_Thoughtyes"
        name="Suicidal_Thoughts"
        className="add-only"
        value="Yes"
      />
    </td>
    <td className="w-60">
      <input
        type="radio"
        id="rb_Suicidal_ThoughtNo"
        name="Suicidal_Thoughts"
        className="add-only"
        value="No"
      />
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <h5>
        If YES to 2, ask questions 3, 4, 5, and 6. If NO to 2, go
        directly to question 6.{" "}
      </h5>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <strong>
        {" "}
        3) Suicidal Thoughts with Method (without Specific Plan or
        Intent to Act):{" "}
      </strong>
      <span className="small">
        Person endorses thoughts of suicide and has thought of a least
        one method during the assessment period. This is different than
        a specific plan with time, place or method details worked out.
        “I thought about taking an overdose but I never made a specific
        plan as to when where or how I would actually do it….and I would
        never go through with it.”
      </span>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <u>
        <strong>
          Have you been thinking about how you might kill yourself?{" "}
        </strong>
      </u>{" "}
    </td>
    <td className="w-20"></td>
    <td className="w-60">
      {" "}
      <input
        type="radio"
        id="rb_Suicidal_Thought_Methodyes"
        name="Suicidal_Thought_Method"
        className="add-only"
        value="Yes"
      />
    </td>
    <td className="w-60">
      <input
        type="radio"
        id="rb_Suicidal_Thought_MethodNo"
        name="Suicidal_Thought_Method"
        className="add-only"
        value="No"
      />
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <strong> 4) Suicidal Intent (without Specific Plan): </strong>
      <span className="small">
        Active suicidal thoughts of killing oneself and patient reports
        having some intent to act on such thoughts, as opposed to “I
        have the thoughts but I definitely will not do anything about
        them.”
      </span>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <u>
        <strong>
          Have you had these thoughts and had some intention of acting
          on them?{" "}
        </strong>
      </u>{" "}
    </td>
    <td className="w-20"></td>
    <td className="w-60">
      {" "}
      <input
        type="radio"
        id="rb_Suicidal_Intent1yes"
        name="Suicidal_Intent1"
        className="add-only"
        value="Yes"
      />
    </td>
    <td className="w-60">
      <input
        type="radio"
        id="rb_Suicidal_Intent1No"
        name="Suicidal_Intent1"
        className="add-only"
        value="No"
      />
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <strong> 5) Suicide Intent (with Specific Plan): </strong>
      <span className="small">
        Thoughts of killing oneself with details of plan fully or
        partially worked out and person has some intent to carry it out.
      </span>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <u>
        <strong>
          Have you started to work out or worked out the details of how
          to kill yourself? Do you intend to carry out this plan?{" "}
        </strong>
      </u>{" "}
    </td>
    <td className="w-20"></td>
    <td className="w-60">
      {" "}
      <input
        type="radio"
        id="rb_Suicidal_Intent2yes"
        name="Suicidal_Intent2"
        className="add-only"
        value="Yes"
      />
    </td>
    <td className="w-60">
      <input
        type="radio"
        id="rb_Suicidal_Intent2No"
        name="Suicidal_Intent2"
        className="add-only"
        value="No"
      />
    </td>
  </tr>
  <tr>
    <td>
      <strong className="w-600"> 6) Suicide Behavior Question :</strong>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      <u>
        <strong>
          {" "}
          Have you ever done anything, started to do anything, or
          prepared to do anything to end your life?”{" "}
        </strong>
      </u>
    </td>
    <td className="w-20"></td>
    <td className="w-60">
      <input
        type="radio"
        id="rb_Suicidal_Intent3yes"
        name="Suicidal_Intent3"
        className="add-only"
        value="Yes"
      />{" "}
    </td>
    <td className="w-60">
      <input
        type="radio"
        id="rb_Suicidal_Intent3No"
        name="Suicidal_Intent3"
        className="add-only"
        value="No"
      />
    </td>
  </tr>
  <tr>
    <td className="w-500">
      <span className="small">
        Examples: Collected pills, obtained a gun, gave away valuables,
        wrote a will or suicide note, took out pills but didn't swallow
        any, held a gun but changed your mind or it was grabbed from
        your hand, went to the roof but didn't jump; or actually took
        pills, tried to shoot yourself, cut yourself, tried to hang
        yourself, etc.
      </span>
    </td>
  </tr>
  <tr>
    <td>
      <strong className="w-550">
        If YES, ask: How long ago did you do any of these?{" "}
      </strong>
    </td>
  </tr>
  <tr>
    <td className="w-600">
      
      <input type="checkbox" id="cbYES_HowlongAgo_1" name="cbYES_HowlongAgo_1" className='add-only' value="YES_HowlongAgo_1" />Over a year ago?&nbsp;&nbsp;&nbsp;
      <input type="checkbox" id="cbYES_HowlongAgo_2" name="cbYES_HowlongAgo_2" className='add-only' value="YES_HowlongAgo_2" />Between three months and a year ago? &nbsp;&nbsp;&nbsp;     
      <input type="checkbox" id="cbYES_HowlongAgo_3" name="cbYES_HowlongAgo_3" className='add-only' value="YES_HowlongAgo_3" />Within the last three months&nbsp;&nbsp;&nbsp;
      <input type="checkbox" id="cbYES_HowlongAgo_4" name="cbYES_HowlongAgo_4" className='add-only' value="YES_HowlongAgo_4" />N/A                          
                        
      
    </td>
  </tr>
</table>
             <h3>J. SUBSTANCE ABUSE HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Substance Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Age of 1<sup>st</sup> Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Age of Heaviest Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency/Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Alcohol</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_1" name="txtAgeFirstUse_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_1" name="txtAgeHeaviestUse_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_1" name="txtAmount_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_1" name="txtLastuse_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cannabis</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_2" name="txtAgeFirstUse_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_2" name="txtAgeHeaviestUse_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_2" name="txtAmount_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_2" name="txtLastuse_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cocaine</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_3" name="txtAgeFirstUse_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_3" name="txtAgeHeaviestUse_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_3" name="txtAmount_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_3" name="txtLastuse_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Stimulants
                            <span className='small'>(Crystal, speed, amphetamines)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_4" name="txtAgeFirstUse_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_4" name="txtAgeHeaviestUse_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_4" name="txtAmount_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_4" name="txtLastuse_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Methamphetamine</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_5" name="txtAgeFirstUse_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_5" name="txtAgeHeaviestUse_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_5" name="txtAmount_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_5" name="txtLastuse_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Inhalants
                            <span className='small'>(LSD, PCP, mushrooms)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_6" name="txtAgeFirstUse_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_6" name="txtAgeHeaviestUse_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_6" name="txtAmount_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_6" name="txtLastuse_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Opioids
                            <span className='small'>(Heroine, Narcotics, Methadone)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_7" name="txtAgeFirstUse_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_7" name="txtAgeHeaviestUse_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_7" name="txtAmount_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_7" name="txtLastuse_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Sedative/Hypnotics
                            <span className='small'>(Valium,  Xanax)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_8" name="txtAgeFirstUse_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_8" name="txtAgeHeaviestUse_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_8" name="txtAmount_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_8" name="txtLastuse_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Designer Drugs
                            <span className='small'>(Herbal, Steroids, Cough Syrup)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_9" name="txtAgeFirstUse_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_9" name="txtAgeHeaviestUse_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_9" name="txtAmount_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_9" name="txtLastuse_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Tobacco</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_10" name="txtAgeFirstUse_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_10" name="txtAgeHeaviestUse_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_10" name="txtAmount_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_10" name="txtLastuse_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_11" name="txtAgeFirstUse_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_11" name="txtAgeHeaviestUse_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_11" name="txtAmount_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_11" name="txtLastuse_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>What consequences has the Individual faced as a result of the Drug/Alcohol use?</span>
                    <span className='small'>
                        (Include hangovers, DT's, Blackouts, Binges, Overdoses, Seizures, GI Bleeding, Job Loss, DUI's, Assaults, Incarcerations, Homicides, etc)</span>
                    <textarea id="txtConsequences" name="txtConsequences" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Longest period of sobriety?</span></td>
                        <td className='w-375'><span className='eleHeader'>When?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLongestSobriety" name="txtLongestSobriety" className='add-only' required />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLongestSobrietyWhen" name="txtLongestSobrietyWhen" className='add-only' required />
                        </td>
                    </tr>
                </table>

                <h3>K. LEGAL HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_1" name="cbLegalHistory_1" className='add-only' value="LegalHistory_1" />
                            Probation Officer Contact and County:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_2" name="cbLegalHistory_2" className='add-only' value="LegalHistory_2" />
                            Parole  Officer Contact and County:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_1" name="txtLegalHistory_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_2" name="txtLegalHistory_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_3" name="cbLegalHistory_3" className='add-only' value="LegalHistory_3" />
                            Number of Arrest in Past 30 Days:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_4" name="cbLegalHistory_4" className='add-only' value="LegalHistory_4" />
                            Number of arrests in the past year:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_3" name="txtLegalHistory_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_4" name="txtLegalHistory_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_5" name="cbLegalHistory_5" className='add-only' value="LegalHistory_5" />
                            Current Pending Charges:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_6" name="cbLegalHistory_6" className='add-only' value="LegalHistory_6" />
                            DFCS/CPS and County
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_5" name="txtLegalHistory_5" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_6" name="txtLegalHistory_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_7" name="cbLegalHistory_7" className='add-only' value="LegalHistory_7" />
                            Restraining Order
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_8" name="cbLegalHistory_8" className='add-only' value="LegalHistory_8" />
                            None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_7" name="txtLegalHistory_7" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
          <h3>L. FAMILY HISTORY</h3>
                <p className="w-750">
                    <strong>HOUSEHOLD COMPOSITION AT TIME OF ASSESSMENT</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-300'><span className='eleHeader'>Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Relationship to Individual</span></td>
                        <td className='w-200'><span className='eleHeader'>Date of Birth</span></td>
                        <td className='w-100'><span className='eleHeader'>Age</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_1" name="txtName_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_1" name="txtRelationshipIndividual_1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_1" name="txtDob_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_1" name="txtAge_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_2" name="txtName_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_2" name="txtRelationshipIndividual_2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_2" name="txtDob_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_2" name="txtAge_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_3" name="txtName_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_3" name="txtRelationshipIndividual_3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_3" name="txtDob_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_3" name="txtAge_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_4" name="txtName_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_4" name="txtRelationshipIndividual_4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_4" name="txtDob_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_4" name="txtAge_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>LIVING SITUATION </span>
                    <span className='small'>(Check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_1" name="cbLivingSituation_1" className='add-only' value="LivingSituation_1" />
                            Home w/ family of origin
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_2" name="cbLivingSituation_2" className='add-only' value="LivingSituation_2" />
                            Independent Living
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_3" name="cbLivingSituation_3" className='add-only' value="LivingSituation_3" />
                            Group Home/Foster Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_4" name="cbLivingSituation_4" className='add-only' value="LivingSituation_4" />
                            Homeless
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_5" name="cbLivingSituation_5" className='add-only' value="LivingSituation_5" />
                            Adequate Housing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_6" name="cbLivingSituation_6" className='add-only' value="LivingSituation_6" />
                            Safety Risks/Hazardous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_7" name="cbLivingSituation_7" className='add-only' value="LivingSituation_7" />
                            Overcrowded
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_8" name="cbLivingSituation_8" className='add-only' value="LivingSituation_8" />
                            Risk of Homelessness
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>What is the family's source(s) of income? Is income monthly, bi-weekly? Is income sufficient for household expenses?</span>
                    <textarea id="txtFamilySourceIncome" name="txtFamilySourceIncome" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>Describe Individual's relationship with biological parents.</span>
                    <textarea id="txtDescribeIndividualRelation" name="txtDescribeIndividualRelation" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>Describe Individual's relationship with siblings. </span>
                    <textarea id="txtDescribeIndividualRelationshipSiblings" name="txtDescribeIndividualRelationshipSiblings" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>Are you experiencing problems in your childhood? </span>
                    <span className='small'>(conflict with parents, siblings, teachers, overweight, etc….)</span>
                    <textarea id="txtExperienceProblems" name="txtExperienceProblems" className='add-only'></textarea>
                </p>
            <h3>Sexuality</h3>
                <table>
                <tr>
                       <td className='w-750'><span className='eleHeader'>Do you consider yourself a member of the Lesbian, Gay, Bisexual and/or Transgender (LGBT) community? </span></td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbSexuality_1" name="cbSexuality_1" className='add-only' value="Sexuality_1" />
                            Yes
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbSexuality_2" name="cbSexuality_2" className='add-only' value="Sexuality_2" />
                            No
                    </td>
                </tr>
                <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuality_3" name="cbSexuality_3" className='add-only' value="Sexuality_3" />
                            No, but I identify as an Ally
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuality_4" name="cbSexuality_4" className='add-only' value="Sexuality_4" />
                            Prefer not to say
                        </td>
                </tr>
                <tr>
                       <td className='w-750'><span className='eleHeader'>What is your Sexual Orientation?</span></td>
                </tr>
                <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuaOrientationl_1" name="cbSexuaOrientationl_1" className='add-only' value="SexuaOrientationl_1" />
                            Straight/Heterosexual
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuaOrientationl_2" name="cbSexuaOrientationl_2" className='add-only' value="SexuaOrientationl_2" />
                            Gay or Lesbian
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuaOrientationl_3" name="cbSexuaOrientationl_3" className='add-only' value="SexuaOrientationl_3" />
                            Bisexual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuaOrientationl_4" name="cbSexuaOrientationl_4" className='add-only' value="SexuaOrientationl_4" />
                            Prefer to self-describe 
                            <input type="text" id="txtcbSexuaOrientationl_4" name="txtcbSexuaOrientationl_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuaOrientationl_5" name="cbSexuaOrientationl_5" className='add-only' value="SexuaOrientationl_3" />
                            Prefer not to say
                        </td>
                        </tr>
                    </table>
                 <h3> TRAUMA & ABUSE HISTORY</h3>
                <p className="w-750">
                    <span className='eleHeader'>Physical Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_1" name="cbPhysicalAbuse_1" className='add-only' value="PhysicalAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_2" name="cbPhysicalAbuse_2" className='add-only' value="PhysicalAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_3" name="cbPhysicalAbuse_3" className='add-only' value="PhysicalAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_4" name="cbPhysicalAbuse_4" className='add-only' value="PhysicalAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_5" name="cbPhysicalAbuse_5" className='add-only' value="PhysicalAbuse_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Domestic Violence</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_1" name="cbDomesticViolence_1" className='add-only' value="DomesticViolence_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_2" name="cbDomesticViolence_2" className='add-only' value="DomesticViolence_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_3" name="cbDomesticViolence_3" className='add-only' value="DomesticViolence_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_4" name="cbDomesticViolence_4" className='add-only' value="DomesticViolence_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_5" name="cbDomesticViolence_5" className='add-only' value="DomesticViolence_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Community Violence</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_1" name="cbCommunityViolence_1" className='add-only' value="CommunityViolence_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_2" name="cbCommunityViolence_2" className='add-only' value="CommunityViolence_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_3" name="cbCommunityViolence_3" className='add-only' value="CommunityViolence_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_4" name="cbCommunityViolence_4" className='add-only' value="CommunityViolence_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_5" name="cbCommunityViolence_5" className='add-only' value="CommunityViolence_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Physical Neglect</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_1" name="cbPhysicalNeglect_1" className='add-only' value="PhysicalNeglect_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_2" name="cbPhysicalNeglect_2" className='add-only' value="PhysicalNeglect_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_3" name="cbPhysicalNeglect_3" className='add-only' value="PhysicalNeglect_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_4" name="cbPhysicalNeglect_4" className='add-only' value="PhysicalNeglect_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_5" name="cbPhysicalNeglect_5" className='add-only' value="PhysicalNeglect_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Emotional Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_1" name="cbEmotionalAbuse_1" className='add-only' value="EmotionalAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_2" name="cbEmotionalAbuse_2" className='add-only' value="EmotionalAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_3" name="cbEmotionalAbuse_3" className='add-only' value="EmotionalAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_4" name="cbEmotionalAbuse_4" className='add-only' value="EmotionalAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_5" name="cbEmotionalAbuse_5" className='add-only' value="EmotionalAbuse_5" />Current
                        </td>

                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Elder Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_1" name="cbElderAbuse_1" className='add-only' value="ElderAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_2" name="cbElderAbuse_2" className='add-only' value="ElderAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_3" name="cbElderAbuse_3" className='add-only' value="ElderAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_4" name="cbElderAbuse_4" className='add-only' value="ElderAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_5" name="cbElderAbuse_5" className='add-only' value="ElderAbuse_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Sexual Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_1" name="cbSexualAbuse_1" className='add-only' value="SexualAbuse_1" />Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_2" name="cbSexualAbuse_2" className='add-only' value="SexualAbuse_2" />Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_3" name="cbSexualAbuse_3" className='add-only' value="SexualAbuse_3" />Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_4" name="cbSexualAbuse_4" className='add-only' value="SexualAbuse_4" />Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_5" name="cbSexualAbuse_5" className='add-only' value="SexualAbuse_5" />Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>No Abuse History</span>
                    <input type="checkbox" id="cbNoAbuseHistory" name="cbNoAbuseHistory" className='add-only' value="NoAbuseHistory" />
                </p>
                <p className="w-750">
                    <span className='eleHeader'>Is there a history of violence in past or current relationships? </span>
                    <span className='small'>Please provide details of Abuse History (if applicable):</span>
                    <textarea id="txtHistoryViolence" name="txtHistoryViolence" className='add-only'></textarea>
                </p>
            <h3>M.	EDUCATION ASSESSMENT</h3>
                <p className="w-750">
                    <span className='eleHeader'>School Setting:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSchoolSetting_1" name="cbSchoolSetting_1" className='add-only' value="SchoolSetting_1" />Enrolled in Mainstream School     
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSchoolSetting_2" name="cbSchoolSetting_2" className='add-only' value="SchoolSetting_2" />Enrolled in Psycho-Education Center    
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSchoolSetting_3" name="cbSchoolSetting_3" className='add-only' value="SchoolSetting_3" />Enrolled in Home School
                        </td>
                    </tr>
                    <tr>
                    <td className='w-250'>
                            <input type="checkbox" id="cbSchoolSetting_4" name="cbSchoolSetting_4" className='add-only' value="SchoolSetting_4" />Enrolled in Alternative School            
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSchoolSetting_5" name="cbSchoolSetting_5" className='add-only' value="SchoolSetting_5" />Enrolled in a Technical School                   
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSchoolSetting_6" name="cbSchoolSetting_6" className='add-only' value="SchoolSetting_6" />Not Enrolled in School
                        </td>
                    </tr>
                </table>
                <h3>Child and Adolescent: </h3>
                <p className="w-750">
                   <span className='eleHeader'>Number of days absent from school in the past month</span>
                </p>
                <table>
                    <tr>
                        <td className='w-600'><input type="text" id="txtChildAdolescent_1" name="txtChildAdolescent_1" className='add-only' /></td>
                        <td className='w-150'><input type="checkbox" id="cbChildAdolescent_1" name="cbChildAdolescent_1" className='add-only' value="ChildAdolescent_1" /> <strong>N/A</strong></td>
                    </tr>
                </table>
                <p className="w-750">
                   <span className='eleHeader'>Last Grade Completed: </span>
                   <input type="text" id="txtChildAdolescent_2" name="txtChildAdolescent_2" className='add-only' />
                </p>
                <p className="w-750">
                   <span className='eleHeader'>H.S. Diploma/GED?:  </span>
                   <input type="radio" id="rbChildAdolescentYes_1" name="rbChildAdolescent_1" className='add-only' value="1" /> Yes &nbsp;
                   <input type="radio" id="rbEmployedNo_1" name="rbChildAdolescent_1" className='add-only' value="0" /> No
                </p>
                <p className="w-750">
                   <span className='eleHeader'>Special Education?:  </span>
                   <input type="radio" id="rbChildAdolescentYes_3" name="rbChildAdolescent_3" className='add-only' value="1" /> Yes &nbsp;
                   <input type="radio" id="rbEmployedNo_3" name="rbChildAdolescent_3" className='add-only' value="0" /> No
                </p>
                <p className="w-750">
                  <span className='eleHeader'>Yrs of Vocation School/College:  </span>
                </p>
                <table>
                    <tr>
                        <td className='w-600'><input type="text" id="txtChildAdolescent_3" name="txtChildAdolescent_3" className='add-only' /></td>
                        <td className='w-150'><input type="checkbox" id="cbChildAdolescent_2" name="cbChildAdolescent_2" className='add-only' value="ChildAdolescent_2" /><strong>N/A</strong></td>
                    </tr>
                </table>
                <p className="w-750">
                  <span className='eleHeader'>Has the Individual ever been suspended or expelled from school and/or bus? </span>
                  <span className='small'>(Include both in-school suspensions and out-of-school suspensions)</span>
                  <textarea id="txtEducationAssessment_1" name="txtEducationAssessment_1" className='add-only'></textarea>
                </p>
                <p className="w-750">
                  <span className='eleHeader'>Does the Individual have frequent absences, truancy? </span>
                  <textarea id="txtEducationAssessment_2" name="txtEducationAssessment_2" className='add-only'></textarea>
                </p>
                <p className="w-750">
                  <span className='eleHeader'>Does the Individual need or is receiving tutoring services? </span>
                  <textarea id="txtEducationAssessment_3" name="txtEducationAssessment_3" className='add-only'></textarea>
                </p>
                <p className="w-750">
                  <span className='eleHeader'>Is the Individual currently failing, and has the Individual ever been retained? </span>
                  <textarea id="txtEducationAssessment_4" name="txtEducationAssessment_4" className='add-only'></textarea>
                </p>
                <p className="w-750">
                  <span className='eleHeader'>What does the Individual like and dislike about school? </span>
                  <textarea id="txtEducationAssessment_5" name="txtEducationAssessment_5" className='add-only'></textarea>
                </p>
                <p className="w-750">
                  <span className='eleHeader'>Describe Individual's Peer relationships?</span>
                  <span className='small'>(Include both the Individual and parent's descriptions)</span>
                  <textarea id="txtEducationAssessment_6" name="txtEducationAssessment_6" className='add-only'></textarea>
                </p>
                <h3>N.	OCCUPATION </h3>
                <span className='small'>(if applicable)</span>
               <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Employment:</span></td>
                        <td className='w-375'><span className='eleHeader'> How Long:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentEmployment" name="txtCurrentEmployment" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="time" id="txtHowLong" name="txtHowLong" className='add-only' />
                        </td>
                    </tr>
                <p className="w-750">
                    <span className='eleHeader'>Have you experienced problems finding employment?
                    </span> <span className='small'>(please explain):
                    </span>
                    <textarea id="txtHaveExperiencedProblems" name="txtHaveExperiencedProblems" className='add-only'></textarea>
                </p>
                </table>
                <h3>O.	MILITARY HISTORY   </h3>
                <span className='small'>(if applicable)</span>
              <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Have you ever served?</span></td>
                        <td className='w-375'><span className='eleHeader'>If yes what branch?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbEmployed2_Yes" name="rbEmployed2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbEmployed2_No" name="rbEmployed2" className='add-only' value="0" /> No
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtBranch" name="txtBranch" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Years in service</span></td>
                        <td className='w-375'><span className='eleHeader'>Discharge Type</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtServiceYears" name="txtServiceYears" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtDischargeType" name="txtDischargeType" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>Were you in combat </span>
                    <span className='small'>(do you experience any flashbacks, uncontrolled anger outbursts, etc...) </span>
                    <textarea id="txtCombat" name="txtCombat" className='add-only'></textarea>
                </p>
                <h3>P.	ETHNIC/CULTURAL ORIENTATION  </h3>
                <span className='small'>(Check all that apply)</span>
                <p className="w-750">
                    <span className='eleHeader'>What type of community were you raised in:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised1" name="cbRaised1" className='add-only' value="Raised1" />Large City
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised2" name="cbRaised2" className='add-only' value="Raised2" />Medium Size city
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised3" name="cbRaised3" className='add-only' value="Raised3" />Large Town
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised4" name="cbRaised4" className='add-only' value="Raised4" />Small Town
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRaised5" name="cbRaised5" className='add-only' value="Raised5" />Rural
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className='eleHeader'>What cultural practices linked to your racial/ethnic background are important to you, as it relates to your treatment?</span>
                    <textarea id="txtCulturalPractices" name="txtCulturalPractices" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What are your hobbies or leisure preferences:</span>
                    <textarea id="txtHobbies" name="txtHobbies" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What are your spiritual preferences:</span>
                    <textarea id="txtSpiritualPreferences" name="txtSpiritualPreferences" className='add-only'></textarea>
                </p>
           <h3>Q.	SOCIAL SERVICES/SUPPORT NEEDS  </h3>
                <span className='small'>(Check all that apply)</span>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_1" name="cbSocialServices_1" className='add-only' value="SocialServices_1" />Income maintenance
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_2" name="cbSocialServices_2" className='add-only' value="SocialServices_2" />Food
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_3" name="cbSocialServices_3" className='add-only' value="SocialServices_3" />Clothing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_4" name="cbSocialServices_4" className='add-only' value="SocialServices_4" />Housing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_5" name="cbSocialServices_5" className='add-only' value="SocialServices_5" />Medical
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_6" name="cbSocialServices_6" className='add-only' value="SocialServices_6" />Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_7" name="cbSocialServices_7" className='add-only' value="SocialServices_7" />Vocational
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_8" name="cbSocialServices_8" className='add-only' value="SocialServices_8" />Leisure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_9" name="cbSocialServices_9" className='add-only' value="SocialServices_9" />Social
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_10" name="cbSocialServices_10" className='add-only' value="SocialServices_10" />Other:
                            <input type="text" id="txtSocialServices_Other" name="txtSocialServices_Other" className='add-only' />
                        </td>
                    </tr>
                </table>
            <h3>R. FACTORS THAT MAY AFFECT LEARNING/TREATMENT</h3>
                <span className='small'>(Check all that apply)</span>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_1" name="cbFactorsLearning_1" className='add-only' value="FactorsLearning_1" />None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_2" name="cbFactorsLearning_2" className='add-only' value="FactorsLearning_2" />Cognitive Impairment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_3" name="cbFactorsLearning_3" className='add-only' value="FactorsLearning_3" />Lack of Motivation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_4" name="cbFactorsLearning_4" className='add-only' value="FactorsLearning_4" />Abuse/Neglect
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_5" name="cbFactorsLearning_5" className='add-only' value="FactorsLearning_5" />Pain
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_6" name="cbFactorsLearning_6" className='add-only' value="FactorsLearning_6" />Language Barrier
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_7" name="cbFactorsLearning_7" className='add-only' value="FactorsLearning_7" />Impaired ability of read/write
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_8" name="cbFactorsLearning_8" className='add-only' value="FactorsLearning_8" />Sensory Impairment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_9" name="cbFactorsLearning_9" className='add-only' value="FactorsLearning_9" />Fatigue
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_10" name="cbFactorsLearning_10" className='add-only' value="FactorsLearning_10" />Physical Disability
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_11" name="cbFactorsLearning_11" className='add-only' value="FactorsLearning_11" />Acute/Chronic Organicity
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}>
                            <input type="checkbox" id="cbFactorsLearning_12" name="cbFactorsLearning_12" className='add-only' value="FactorsLearning_12" />Other
                            <input type="text" id="txtFactorsLearning_12" name="txtFactorsLearning_12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>S. SNAP: STRENGTHS, NEEDS, ABILITIES, PREFERENCES</h3>
                <p className="w-750">
                    <span className='eleHeader'>What strengths does the Individual have that affects their quality of life?</span>
                    <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    <textarea id="txtWhatStrengths" name="txtWhatStrengths" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What is needed to increase the Individual's quality of life?</span>
                    <span className='small'>(Name specific interventions, resources for biological, psychological, and social/environmental barriers)</span>
                    <textarea id="txtIndividualQualityLife" name="txtIndividualQualityLife" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What are the Individual's abilities and skills that would help increase his/her quality of life?</span>
                    <span className='small'>(This should include personality traits, work skills, academic skills)</span>
                    <textarea id="txtIndividualAbilities" name="txtIndividualAbilities" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What are the family's strengths?</span>
                    <textarea id="txtFamilyStrengths" name="txtFamilyStrengths" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What are the Individual and family's expectation of and preferences for this service?</span>
                    <span className='small'> (This should include the Individual's own words of his/her expected outcome)</span>
                    <textarea id="txtFamilyexpectation" name="txtFamilyexpectation" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What are the Individual's hopes, dreams, or personal life goals?</span>
                    <span className='small'>(This should include the Individual's own words)</span>
                    <textarea id="txtIndividualExpectation" name="txtIndividualExpectation" className='add-only'></textarea>
                </p>
                <h3>S2. Hopes / Choices / Preferences / Desired Outcomes</h3>
                <p className="w-750">
                    <span className='eleHeader'>What Hopes does the Individual have regarding their treatment?</span>
                    <span className='small'>(This should include family, friend, teacher  supports, hobbies, community resources, education)</span>
                    <textarea id="txtWhatHopes" name="txtWhatHopes" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What Choices does the Individual have regarding meeting his/her needs?</span>
                    <span className='small'>(Name specific resources, community opportunities, etc.)</span>
                    <textarea id="txtWhatChoices" name="txtWhatChoices" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What Preferences does the Individual have regarding his/her treatment?</span>
                    <span className='small'>(This should be male/female community staff, meeting location and/or time, staff with specific specialty, etc.)</span>
                    <textarea id="txtWhatPreferences" name="txtWhatPreferences" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>What are the Individual's Desired Outcomes for treatment?</span>
                    <span className='small'>(What does the Individual expect to achieve throughout his/her treatment?)</span>
                    <textarea id="txtWhatDesired" name="txtWhatDesired" className='add-only'></textarea>
                </p>
                 <h3> T.	STAGE OF CHANGE</h3>
                 <h5> Stage of Change:</h5>
                <p className="w-750">
                    <strong>Include: Inferring Need (Does the Individual feel they are successful and satisfied with their life?) Personal Awareness (Is the Individual aware of their needs, wants, desires, dreams, skills, aptitudes, decision making process, etc…), Environmental Awareness (Does the Individual know the characteristics, requirements and conditions of what is available or exists in their living, learning, working and /or social environments?, Personal Closeness (Is the Individual close or trusting of others to help them?)</strong>
                </p>
                <p className="w-750">
                    <strong>What Stage of Change is the Individual In:</strong>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>1.	Pre-Contemplation </span>
                    <span className='small'>(No intentions of changing)</span>
                    <textarea id="txtPreContemplation" name="txtPreContemplation" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>2.	Contemplation </span>
                    <span className='small'>(Recognizing there's a problem with no commitment to change)</span>
                    <textarea id="txtContemplation" name="txtContemplation" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>3.	Preparation </span>
                    <span className='small'>(Intent upon taking action soon and often report some steps in that direction)</span>
                    <textarea id="txtPreparation" name="txtPreparation" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>4.	Action </span>
                    <span className='small'>(Is aware a problem exists and actively modifies their behavior, experiences and environment in order to overcome the problem. Commitment is clear and a great deal of effort is expended towards making changes)</span>
                    <textarea id="txtAction" name="txtAction" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <span className='eleHeader'>5.	Maintenance
                    </span>
                    <span className='small'>(Has made a sustained change wherein a new pattern of behavior has replaced the old. Behavior is firmly established and threat of relapse becomes less intense)</span>
                    <textarea id="txtMaintenance" name="txtMaintenance" className='add-only'></textarea>
                </p>
                <p className="w-750">
                    <strong>6.***(Relapse)</strong>
                </p>
           <h3>U. DSM-5/ ICD-10 DIAGNOSTIC IMPRESSION:</h3>
              <p className="w-750">
                    <span className='eleHeader'>Co-Occurring Disorder</span>
                    <span className='small'>(More than one diagnosis of any kind warrants a co-occurring disorder, not just substance abuse)
                    </span>
                    <input type="radio" id="rbCoOccurring_Yes" name="rbCoOccurring" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbCoOccurring_No" name="rbCoOccurring" className='add-only' value="0" /> No
                </p>
                <p className="w-750">
                    <textarea id="txtDsmIcdDiagnosticImpression" name="txtDsmIcdDiagnosticImpression" className='add-only'></textarea>
                </p>
            <h3>V. INTERPRETIVE SUMMARY</h3>
                <p className="w-750">
                    <span className='eleHeader'>(Please write a statement that integrates all assessments: describes central themes; reason (s) the individual is seeking services; individual's acceptance or understanding of his/her problems/needs and strategies for relapse prevention; individual's apparent strengths and functional limitations; description of potential barriers to community inclusion/integration and successful attainment of goals and movement towards recovery; complicating conditions/disorders, including a discussion of substance abuse patterns and serious medical conditions; explanation of choice goals to be worked on;  description of risk versus choice issues.  The summary should begin with a brief description of the individual)(Include SNAP as a part of summary). Identify whether Individual meets IFI or CORE criteria and concluding statement.
                    </span>
                    <textarea id="txtInterpretiveSummaryA" name="txtInterpretiveSummaryA" className='add-only'></textarea>
                </p>
            <h3>W1.	IFI ADMISSION CRITERIA (DBHDD)</h3>
                <p className="w-750"><input type="checkbox" id="cbIFIAdmissionCriteria_1" name="cbIFIAdmissionCriteria_1" className='add-only' value="IFIAdmissionCriteria_1" />1.Youth has a diagnosis and duration of symptoms which classify the illness as SED (youth with SED have a diagnosable mental, behavioral, or emotional disorder of sufficient duration to meet DSM diagnostic criteria and results in a functional impairment which substantially interferes with or limits the child's role or functioning in the family, school, or community activities) and/or is diagnosed with a Substance Related Disorder; <strong>and one or more of the following: </strong> </p>
                <p className="w-750"><input type="checkbox" id="cbIFIAdmissionCriteria_2" name="cbIFIAdmissionCriteria_2" className='add-only' value="IFIAdmissionCriteria_2" />2. Youth has received documented services through other services such as Non-Intensive Outpatient Services and exhausted these less intensive out-patient resources. Treatment at a lower intensity has been attempted or given serious consideration, but the risk factors for out-of-home placement are compelling (see item G.1. below); The less intensive services previously provided must be documented in the clinical record (even if it via by self-report of the youth and family); or </p> 
                <p className="w-750"><input type="checkbox" id="cbIFIAdmissionCriteria_3" name="cbIFIAdmissionCriteria_3" className='add-only' value="IFIAdmissionCriteria_3" />3. Youth and/or family has insufficient or severely limited resources or skills necessary to cope with an immediate behavioral health crisis; or </p>
                <p className="w-750"><input type="checkbox" id="cbIFIAdmissionCriteria_4" name="cbIFIAdmissionCriteria_4" className='add-only' value="IFIAdmissionCriteria_4" />4. Youth and/or family behavioral health issues are unmanageable in traditional outpatient treatment and require intensive, coordinated clinical and supportive intervention; or </p> 
                <p className="w-750"><input type="checkbox" id="cbIFIAdmissionCriteria_5" name="cbIFIAdmissionCriteria_5" className='add-only' value="IFIAdmissionCriteria_5" />5. Because of behavioral health issues, the youth is at immediate risk of out-of-home placement; or </p>
                <p className="w-750"> <input type="checkbox" id="cbIFIAdmissionCriteria_6" name="cbIFIAdmissionCriteria_6" className='add-only' value="IFIAdmissionCriteria_6" />6. Because of behavioral health issues, the youth is at immediate risk of legal system intervention or is currently involved with DJJ for behaviors/issues related to SED and/or the Substance-related disorder. </p>
            <h3>W2.	CORE ADMISSION CRITERIA (DBHDD)</h3>
                <p className="w-750"><input type="checkbox" id="cbCOREAdmissionCriteria_1" name="cbCOREAdmissionCriteria_1" className='add-only' value="COREAdmissionCriteria_1" />Individual is affected by an emotional disturbance or substance related disorder. </p>
                <p className="w-750"><input type="checkbox" id="cbCOREAdmissionCriteria_2" name="cbCOREAdmissionCriteria_2" className='add-only' value="COREAdmissionCriteria_2" />Individual has shown early indications of behaviors that could be disruptive to the community and the family/support system if behavior intensified. </p> 
                <p className="w-750"><input type="checkbox" id="cbCOREAdmissionCriteria_3" name="cbCOREAdmissionCriteria_3" className='add-only' value="COREAdmissionCriteria_3" />Individual has shown early indications of behaviors/ functional problems that could cause risk of removal from the home if problems intensified. </p>
                <p className="w-750"><input type="checkbox" id="cbCOREAdmissionCriteria_4" name="cbCOREAdmissionCriteria_4" className='add-only' value="COREAdmissionCriteria_4" />Individual has shown early indications of poor school performance (poor grades, disruptive behavior, lack of motivation, suspension).</p> 
                <p className="w-750"><input type="checkbox" id="cbCOREAdmissionCriteria_5" name="cbCOREAdmissionCriteria_5" className='add-only' value="COREAdmissionCriteria_5" />Individual has shown early indications of delinquent behaviors that could result in legal system involvement.</p>
                <p className="w-750"> <input type="checkbox" id="cbCOREAdmissionCriteria_6" name="cbCOREAdmissionCriteria_6" className='add-only' value="COREAdmissionCriteria_6" />Individual has shown early indications of behavioral/functional problems that could result in multiple agency involvement if problems intensified. </p>
                <p className="w-750"> <input type="checkbox" id="cbCOREAdmissionCriteria_7" name="cbCOREAdmissionCriteria_7" className='add-only' value="COREAdmissionCriteria_7" />Individual demonstrates behaviors that are a risk of harm to self, others, or property. </p> 
                <p className="w-750"> <input type="checkbox" id="cbCOREAdmissionCriteria_8" name="cbCOREAdmissionCriteria_8" className='add-only' value="COREAdmissionCriteria_8" />Individual indicates the need for detoxification services.</p>
           
              <h3>X.CANS</h3>
                <p className='w-750'> 
                    <strong>KEY for Traumatic I Adverse Childhood Experience Domain:</strong><br /><br />
                    <strong>0</strong> = No evidence of any trauma of this type <br />
                    <strong>1</strong> = "Mild" exposure, a single incident or suspicion of this trauma or ACE<br />
                    <strong>2</strong> = Child experienced multiple incidents or a moderate degree of this trauma or ACE<br />
                    <strong>3</strong> = Child experienced repeated and severe incidents of this trauma or ACE. 
                </p> 
                <p className='w-750'>
                    <span className=' eleHeader'> TRAUMATIC / ADVERSE CHILDHOOD EXPERIENCES  </span>
                </p> 
                <table>
                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>1.  Sexual Abuse</td>
                        <td className='w-25'><input id="rbSexualAbuse_0" name="rbSexualAbuse" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSexualAbuse_1" name="rbSexualAbuse" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSexualAbuse_2" name="rbSexualAbuse" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSexualAbuse_3" name="rbSexualAbuse" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>2.  Physical Abuse</td>
                        <td className='w-25'><input id="rbPhysicalAbuse_0" name="rbPhysicalAbuse" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbPhysicalAbuse_1" name="rbPhysicalAbuse" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbPhysicalAbuse_2" name="rbPhysicalAbuse" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbPhysicalAbuse_3" name="rbPhysicalAbuse" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>3.  Emotional Abuse</td>
                        <td className='w-25'><input id="rbEmotionalAbuse_0" name="rbEmotionalAbuse" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbEmotionalAbuse_1" name="rbEmotionalAbuse" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbEmotionalAbuse_2" name="rbEmotionalAbuse" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbEmotionalAbuse_3" name="rbEmotionalAbuse" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>4.  Neglect</td>
                        <td className='w-25'><input id="rbNegl_0" name="rbNegl" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbNegl_1" name="rbNegl" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbNegl_2" name="rbNegl" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbNegl_3" name="rbNegl" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>5.  Medical Trauma</td>
                        <td className='w-25'><input id="rbMedicalTrauma_0" name="rbMedicalTrauma" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbMedicalTrauma_1" name="rbMedicalTrauma" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbMedicalTrauma_2" name="rbMedicalTrauma" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbMedicalTrauma_3" name="rbMedicalTrauma" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>6.   Family Violence</td>
                        <td className='w-25'><input id="rbFamilyViolence_0" name="rbFamilyViolence" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbFamilyViolence_1" name="rbFamilyViolence" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbFamilyViolence_2" name="rbFamilyViolence" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbFamilyViolence_3" name="rbFamilyViolence" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>7.   Community Violence</td>
                        <td className='w-25'><input id="rbCommunityViolence_0" name="rbCommunityViolence" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCommunityViolence_1" name="rbCommunityViolence" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCommunityViolence_2" name="rbCommunityViolence" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCommunityViolence_3" name="rbCommunityViolence" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>8.  School Violence</td>
                        <td className='w-25'><input id="rbSchoolViolence_0" name="rbSchoolViolence" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSchoolViolence_1" name="rbSchoolViolence" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSchoolViolence_2" name="rbSchoolViolence" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSchoolViolence_3" name="rbSchoolViolence" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>9.  Natural or Man made Disasters</td>
                        <td className='w-25'><input id="rbNatural_0" name="rbNatural" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbNatural_1" name="rbNatural" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbNatural_2" name="rbNatural" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbNatural_3" name="rbNatural" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>10.  War Affected</td>
                        <td className='w-25'><input id="rbWarAffected_0" name="rbWarAffected" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbWarAffected_1" name="rbWarAffected" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbWarAffected_2" name="rbWarAffected" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbWarAffected_3" name="rbWarAffected" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>11.  Terrorism Affected</td>
                        <td className='w-25'><input id="rbTerrorismAffected_0" name="rbTerrorismAffected" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbTerrorismAffected_1" name="rbTerrorismAffected" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbTerrorismAffected_2" name="rbTerrorismAffected" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbTerrorismAffected_3" name="rbTerrorismAffected" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>12.  Witness/Victim to Criminal Activity</td>
                        <td className='w-25'><input id="rbCriminalActivity_0" name="rbCriminalActivity" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCriminalActivity_1" name="rbCriminalActivity" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCriminalActivity_2" name="rbCriminalActivity" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCriminalActivity_3" name="rbCriminalActivity" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>13.  Parental Criminal Behavior</td>
                        <td className='w-25'><input id="rbParentalCriminal_0" name="rbParentalCriminal" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbParentalCriminal_1" name="rbParentalCriminal" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbParentalCriminal_2" name="rbParentalCriminal" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbParentalCriminal_3" name="rbParentalCriminal" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>14.  Disruption in Care giving</td>
                        <td className='w-25'><input id="rbDisruption_0" name="rbDisruption" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbDisruption_1" name="rbDisruption" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbDisruption_2" name="rbDisruption" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbDisruption_3" name="rbDisruption" type="radio" className='add-only' value="3" /></td>
                    </tr>
                </table>  
                <p className='w-750'>
                    <strong>KEY for Symptoms Related to Traumatic I Adverse Childhood Experiences Domain:</strong><br /><br />
                    <strong>0</strong> = No evidence of a need I no reason to believe that the rated item requires any action.  <br />
                    <strong>1</strong> = A need for watchful waiting, monitoring or possibly preventive action. <br />
                    <strong>2</strong> = A need for action. Some strategy is needed to address the problem/need.<br />
                    <strong>3</strong> = A need for immediate or intensive action. This level indicates an immediate safety concern or a priority for intervention.

                </p> 
                <p className='w-750'>
                    <span className=' eleHeader'> TRAUMATIC STRESS SYMPTOMS </span>
                </p> 
                <table>
                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>15.  Adjustment to Trauma</td>
                        <td className='w-25'><input id="rbAdjustment_0" name="rbAdjustment" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbAdjustment_1" name="rbAdjustment" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbAdjustment_2" name="rbAdjustment" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbAdjustment_3" name="rbAdjustment" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>16. Traumatic Grief</td>
                        <td className='w-25'><input id="rbTraumaticGrief_0" name="rbTraumaticGrief" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbTraumaticGrief_1" name="rbTraumaticGrief" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbTraumaticGrief_2" name="rbTraumaticGrief" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbTraumaticGrief_3" name="rbTraumaticGrief" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>17.  Re-experiencing</td>
                        <td className='w-25'><input id="rbReExperiencing_0" name="rbReExperiencing" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbReExperiencing_1" name="rbReExperiencing" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbReExperiencing_2" name="rbReExperiencing" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbReExperiencing_3" name="rbReExperiencing" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>18.  Hyperarousal</td>
                        <td className='w-25'><input id="rbHyperarousal_0" name="rbHyperarousal" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbHyperarousal_1" name="rbHyperarousal" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbHyperarousal_2" name="rbHyperarousal" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbHyperarousal_3" name="rbHyperarousal" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> 19. Avoidance</td>
                        <td className='w-25'><input id="rbAvoidance_0" name="rbAvoidance" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbAvoidance_1" name="rbAvoidance" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbAvoidance_2" name="rbAvoidance" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbAvoidance_3" name="rbAvoidance" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'> 20. Numbing</td>
                        <td className='w-25'><input id="rbNumbing_0" name="rbNumbing" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbNumbing_1" name="rbNumbing" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbNumbing_2" name="rbNumbing" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbNumbing_3" name="rbNumbing" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>21. Dissociation</td>
                        <td className='w-25'><input id="rbDissociation_0" name="rbDissociation" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbDissociation_1" name="rbDissociation" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbDissociation_2" name="rbDissociation" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbDissociation_3" name="rbDissociation" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>22.  Affective/Physiological Dys.</td>
                        <td className='w-25'><input id="rbPhysiological_0" name="rbPhysiological" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbPhysiological_1" name="rbPhysiological" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbPhysiological_2" name="rbPhysiological" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbPhysiological_3" name="rbPhysiological" type="radio" className='add-only' value="3" /></td>
                    </tr>
                </table> 
                <p className='w-750'>
                    <span className=' eleHeader'> CHILD STRENGTHS  </span>
                </p> 
                <p className='w-750'> 
                    <strong>KEY for Strengths Domain: </strong><br /> <br />
                    <strong>0</strong> = Centerpiece strength <br />
                    <strong>1</strong> = Useful strength <br />
                    <strong>2</strong> = Identified strength <br />
                    <strong>3</strong> = Not yet identified strength I NO information about a strength in this area 
                </p> 
                <table>
                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                        <td className='w-25'><b>NA</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>23. Family </td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Family_0" name="rbCHILDSTRENGTHS_Family" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Family_1" name="rbCHILDSTRENGTHS_Family" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Family_2" name="rbCHILDSTRENGTHS_Family" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Family_3" name="rbCHILDSTRENGTHS_Family" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>24. Interpersonal </td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Interpersonal_0" name="rbCHILDSTRENGTHS_Interpersonal" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Interpersonal_1" name="rbCHILDSTRENGTHS_Interpersonal" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Interpersonal_2" name="rbCHILDSTRENGTHS_Interpersonal" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Interpersonal_3" name="rbCHILDSTRENGTHS_Interpersonal" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>25. Educational </td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Educational_0" name="rbCHILDSTRENGTHS_Educational" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Educational_1" name="rbCHILDSTRENGTHS_Educational" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Educational_2" name="rbCHILDSTRENGTHS_Educational" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Educational_3" name="rbCHILDSTRENGTHS_Educational" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Educational_NA" name="rbCHILDSTRENGTHS_Educational" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>26. Vocational </td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Vocational_0" name="rbCHILDSTRENGTHS_Educational" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Vocational_1" name="rbCHILDSTRENGTHS_Vocational" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Vocational_2" name="rbCHILDSTRENGTHS_Vocational" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Vocational_3" name="rbCHILDSTRENGTHS_Vocational" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Educational_NA" name="rbCHILDSTRENGTHS_Educational" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>27. Coping and Savoring Skills</td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SavoringSkills_0" name="rbCHILDSTRENGTHS_SavoringSkills" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SavoringSkills_1" name="rbCHILDSTRENGTHS_SavoringSkills" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SavoringSkills_2" name="rbCHILDSTRENGTHS_SavoringSkills" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SavoringSkills_3" name="rbCHILDSTRENGTHS_SavoringSkills" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>28. Optimism </td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Optimism_0" name="rbCHILDSTRENGTHS_Optimism" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Optimism_1" name="rbCHILDSTRENGTHS_Optimism" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Optimism_2" name="rbCHILDSTRENGTHS_Optimism" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_Optimism_3" name="rbCHILDSTRENGTHS_Optimism" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>29. Talents/lnterests </td>
                        <td className='w-25'><input id="rbCorbCHILDSTRENGTHS_Talentslnterests_0" name="rbCorbCHILDSTRENGTHS_Talentslnterests" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCorbCHILDSTRENGTHS_Talentslnterests_1" name="rbCorbCHILDSTRENGTHS_Talentslnterests" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCorbCHILDSTRENGTHS_Talentslnterests_2" name="rbCorbCHILDSTRENGTHS_Talentslnterests" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCorbCHILDSTRENGTHS_Talentslnterests_3" name="rbCorbCHILDSTRENGTHS_Talentslnterests" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>30. Spiritual/Religious</td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SpiritualReligious_0" name="rbCHILDSTRENGTHS_SpiritualReligious" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SpiritualReligious_1" name="rbCHILDSTRENGTHS_SpiritualReligious" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SpiritualReligious_2" name="rbCHILDSTRENGTHS_SpiritualReligious" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_SpiritualReligious_3" name="rbCHILDSTRENGTHS_SpiritualReligious" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>31. Community Life</td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_CommunityLife_0" name="rbCHILDSTRENGTHS_CommunityLife" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_CommunityLife_1" name="rbCHILDSTRENGTHS_CommunityLife" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_CommunityLife_2" name="rbCHILDSTRENGTHS_CommunityLife" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_CommunityLife_3" name="rbCHILDSTRENGTHS_CommunityLife" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>32. Relationship Permanence </td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_RelationshipPermanence_0" name="rbCHILDSTRENGTHS_RelationshipPermanence" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_RelationshipPermanence_1" name="rbCHILDSTRENGTHS_RelationshipPermanence" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_RelationshipPermanence_2" name="rbCHILDSTRENGTHS_RelationshipPermanence" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCHILDSTRENGTHS_RelationshipPermanence_3" name="rbCHILDSTRENGTHS_RelationshipPermanence" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>33. Resilience</td>
                        <td className='w-25'><input id="rbTerbCHILDSTRENGTHS_Resilience_0" name="rbTerbCHILDSTRENGTHS_Resilience" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbTerbCHILDSTRENGTHS_Resilience_1" name="rbTerbCHILDSTRENGTHS_Resilience" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbTerbCHILDSTRENGTHS_Resilience_2" name="rbTerbCHILDSTRENGTHS_Resilience" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbTerbCHILDSTRENGTHS_Resilience_3" name="rbTerbCHILDSTRENGTHS_Resilience" type="radio" className='add-only' value="3" /></td>
                    </tr>

                </table> 
               <p className='w-750'>
                    <strong>KEY for Other Need Domains:  </strong><br /><br />
                    <strong>0</strong> = No evidence of a need I no reason to believe that the rated item requires any action.  <br />
                    <strong>1</strong> = A need for watchful waiting, monitoring or possibly preventive action.<br />
                    <strong>2</strong> =  A need for action. Some strategy is needed to address the problem/need <br />
                    <strong>3</strong> = A need for immediate or intensive action. This level indicates an immediate safety concern or a priority for intervention.
              </p> 
                <p className='w-750'>
                    <span className=' eleHeader'> LIFE FUNCTIONING DOMAIN  </span>
                </p> 
                <table>
                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>34. Family</td>
                        <td className='w-25'><input id="rbFamilys_0" name="rbFamilys" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbFamilys_1" name="rbFamilys" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbFamilys_2" name="rbFamilys" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbFamilys_3" name="rbFamilys" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>35. Living Situation</td>
                        <td className='w-25'><input id="rbLiving_0" name="rbLiving" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbLiving_1" name="rbLiving" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbLiving_2" name="rbLiving" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbLiving_3" name="rbLiving" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>36. Social Functioning</td>
                        <td className='w-25'><input id="rbSocialFunctioning_0" name="rbSocialFunctioning" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSocialFunctioning_1" name="rbSocialFunctioning" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSocialFunctioning_2" name="rbSocialFunctioning" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSocialFunctioning_3" name="rbSocialFunctioning" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>37. Developmental</td>
                        <td className='w-25'><input id="rbDevelopmental_0" name="rbDevelopmental" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbDevelopmental_1" name="rbDevelopmental" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbDevelopmental_2" name="rbDevelopmental" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbDevelopmental_3" name="rbDevelopmental" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>38. Recreational</td>
                        <td className='w-25'><input id="rbRecreational_0" name="rbRecreational" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbRecreational_1" name="rbRecreational" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbRecreational_2" name="rbRecreational" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbRecreational_3" name="rbRecreational" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>39. Legal</td>
                        <td className='w-25'><input id="rbLegal_0" name="rbLegal" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbLegal_1" name="rbLegal" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbLegal_2" name="rbLegal" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbLegal_3" name="rbLegal" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>40. Medical</td>
                        <td className='w-25'><input id="rbMedical_0" name="rbMedical" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbMedical_1" name="rbMedical" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbMedical_2" name="rbMedical" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbMedical_3" name="rbMedical" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>41. Physical</td>
                        <td className='w-25'><input id="rbPhysical_0" name="rbPhysical" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbPhysical_1" name="rbPhysical" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbPhysical_2" name="rbPhysical" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbPhysical_3" name="rbPhysical" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>42. Sleep</td>
                        <td className='w-25'><input id="rbLifeDomainSleep_0" name="rbLifeDomainSleep" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbLifeDomainSleep_1" name="rbLifeDomainSleep" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbLifeDomainSleep_2" name="rbLifeDomainSleep" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbLifeDomainSleep_3" name="rbLifeDomainSleep" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>43. Sexual Development</td>
                        <td className='w-25'><input id="rbSexualDevelopment_0" name="rbSexualDevelopment" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSexualDevelopment_1" name="rbSexualDevelopment" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSexualDevelopment_2" name="rbSexualDevelopment" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSexualDevelopment_3" name="rbSexualDevelopment" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>44. School Behavior</td>
                        <td className='w-25'><input id="rbSexualBehavior_0" name="rbSexualBehavior" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSexualBehavior_1" name="rbSexualBehavior" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSexualBehavior_2" name="rbSexualBehavior" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSexualBehavior_3" name="rbSexualBehavior" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>45. School Achievement</td>
                        <td className='w-25'><input id="rbSchoolAchievement_0" name="rbSchoolAchievement" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSchoolAchievement_1" name="rbSchoolAchievement" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSchoolAchievement_2" name="rbSchoolAchievement" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSchoolAchievement_3" name="rbSchoolAchievement" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>46. School Attendance </td>
                        <td className='w-25'><input id="rbSchoolAttend_0" name="rbSchoolAttend" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSchoolAttend_1" name="rbSchoolAttend" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSchoolAttend_2" name="rbSchoolAttend" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSchoolAttend_3" name="rbSchoolAttend" type="radio" className='add-only' value="3" /></td>
                    </tr>

                </table> 
                <p className='w-750'>
                    <span className=' eleHeader'> ACCULTURATION </span>
                </p>

                <table>

                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>47. Language</td>
                        <td className='w-25'><input id="rbLanguage_0" name="rbLanguage" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbLanguage_1" name="rbLanguage" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbLanguage_2" name="rbLanguage" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbLanguage_3" name="rbLanguage" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>48. Identity</td>
                        <td className='w-25'><input id="rbIdentity_0" name="rbIdentity" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbIdentity_1" name="rbIdentity" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbIdentity_2" name="rbIdentity" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbIdentity_3" name="rbIdentity" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>49.  Ritual</td>
                        <td className='w-25'><input id="rbRitual_0" name="rbRitual" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbRitual_1" name="rbRitual" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbRitual_2" name="rbRitual" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbRitual_3" name="rbRitual" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>50.  Cultural Stress</td>
                        <td className='w-25'><input id="rbCulturalStress_0" name="rbCulturalStress" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCulturalStress_1" name="rbCulturalStress" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCulturalStress_2" name="rbCulturalStress" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCulturalStress_3" name="rbCulturalStress" type="radio" className='add-only' value="3" /></td>
                    </tr>
                </table> 
                <p className='w-750'>
                    <span className=' eleHeader'> CHILD BEHAVIORAL  EMOTIONAL NEEDS </span>
                </p> 
                <table>

                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>51. Psychosis</td>
                        <td className='w-25'><input id="rbPsych_0" name="rbPsych" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbPsych_1" name="rbPsych" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbPsych_2" name="rbPsych" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbPsych_3" name="rbPsych" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>52.  Attention/Concentration</td>
                        <td className='w-25'><input id="rbAttention_0" name="rbAttention" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbAttention_1" name="rbAttention" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbAttention_2" name="rbAttention" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbAttention_3" name="rbAttention" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>53. Impulsivity</td>
                        <td className='w-25'><input id="rbImpulsivity_0" name="rbImpulsivity" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbImpulsivity_1" name="rbImpulsivity" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbImpulsivity_2" name="rbImpulsivity" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbImpulsivity_3" name="rbImpulsivity" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>54.  Depression</td>
                        <td className='w-25'><input id="rbDepress_0" name="rbDepress" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbDepress_1" name="rbDepress" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbDepress_2" name="rbDepress" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbDepress_3" name="rbDepress" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>55.  Anxiety</td>
                        <td className='w-25'><input id="rbAnxiety_0" name="rbAnxiety" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbAnxiety_1" name="rbAnxiety" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbAnxiety_2" name="rbAnxiety" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbAnxiety_3" name="rbAnxiety" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>56.  Oppositional</td>
                        <td className='w-25'><input id="rbOpposition_0" name="rbOpposition" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbOpposition_1" name="rbOpposition" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbOpposition_2" name="rbOpposition" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbOpposition_3" name="rbOpposition" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>57.  Conduct</td>
                        <td className='w-25'><input id="rbConduct_0" name="rbConduct" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbConduct_1" name="rbConduct" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbConduct_2" name="rbConduct" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbConduct_3" name="rbConduct" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>58.  Substance Use</td>
                        <td className='w-25'><input id="rbSubstanceUse_0" name="rbSubstanceUse" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSubstanceUse_1" name="rbSubstanceUse" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSubstanceUse_2" name="rbSubstanceUse" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSubstanceUse_3" name="rbSubstanceUse" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>59.  Attachment </td>
                        <td className='w-25'><input id="rbAttach_0" name="rbAttach" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbAttach_1" name="rbAttach" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbAttach_2" name="rbAttach" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbAttach_3" name="rbAttach" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>60.  Eating Disturbance</td>
                        <td className='w-25'><input id="rbEating_0" name="rbEating" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbEating_1" name="rbEating" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbEating_2" name="rbEating" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbEating_3" name="rbEating" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>61.  Behavioral Regression</td>
                        <td className='w-25'><input id="rbBehavioral_0" name="rbBehavioral" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbBehavioral_1" name="rbBehavioral" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbBehavioral_2" name="rbBehavioral" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbBehavioral_3" name="rbBehavioral" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>62.  Somatization</td>
                        <td className='w-25'><input id="rbSomatization_0" name="rbSomatization" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSomatization_1" name="rbSomatization" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSomatization_2" name="rbSomatization" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSomatization_3" name="rbSomatization" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>63.  Anger Control</td>
                        <td className='w-25'><input id="rbAngerControl_0" name="rbAngerControl" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbAngerControl_1" name="rbAngerControl" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbAngerControl_2" name="rbAngerControl" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbAngerControl_3" name="rbAngerControl" type="radio" className='add-only' value="3" /></td>
                    </tr>
                </table> 

                <p className='w-750'>
                    <span className=' eleHeader'>CHILD RISK BEHAVIORS </span>
                </p> 
                <table>

                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>64.  Suicide Risk</td>
                        <td className='w-25'><input id="rbSuicideRisk_0" name="rbSuicideRisk" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSuicideRisk_1" name="rbSuicideRisk" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSuicideRisk_2" name="rbSuicideRisk" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSuicideRisk_3" name="rbSuicideRisk" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>65.  Non-Suicidal Self-Injury</td>
                        <td className='w-25'><input id="rbNonSuicidal_0" name="rbNonSuicidal" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbNonSuicidal_1" name="rbNonSuicidal" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbNonSuicidal_2" name="rbNonSuicidal" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbNonSuicidal_3" name="rbNonSuicidal" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>66. Other Self-Harm </td>
                        <td className='w-25'><input id="rbOtherSelf_0" name="rbOtherSelf" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbOtherSelf_1" name="rbOtherSelf" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbOtherSelf_2" name="rbOtherSelf" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbOtherSelf_3" name="rbOtherSelf" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>67. Danger to Others</td>
                        <td className='w-25'><input id="rbDanger_0" name="rbDanger" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbDanger_1" name="rbDanger" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbDanger_2" name="rbDanger" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbDanger_3" name="rbDanger" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>68. Sexual Aggression</td>
                        <td className='w-25'><input id="rbSexualAggression_0" name="rbSexualAggression" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSexualAggression_1" name="rbSexualAggression" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSexualAggression_2" name="rbSexualAggression" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSexualAggression_3" name="rbSexualAggression" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>69. Runaway</td>
                        <td className='w-25'><input id="rbRunaway_0" name="rbRunaway" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbRunaway_1" name="rbRunaway" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbRunaway_2" name="rbRunaway" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbRunaway_3" name="rbRunaway" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>70. Delinquency</td>
                        <td className='w-25'><input id="rbDelinquency_0" name="rbDelinquency" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbDelinquency_1" name="rbDelinquency" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbDelinquency_2" name="rbDelinquency" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbDelinquency_3" name="rbDelinquency" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>71. Judgment</td>
                        <td className='w-25'><input id="rbJudgment_0" name="rbJudgment" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbJudgment_1" name="rbJudgment" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbJudgment_2" name="rbJudgment" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbJudgment_3" name="rbJudgment" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>72. Fire Setting</td>
                        <td className='w-25'><input id="rbFireSetting_0" name="rbFireSetting" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbFireSetting_1" name="rbFireSetting" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbFireSetting_2" name="rbFireSetting" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbFireSetting_3" name="rbFireSetting" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>73. Intentional Misbehavior</td>
                        <td className='w-25'><input id="rbMisbehavior_0" name="rbMisbehavior" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbMisbehavior_1" name="rbMisbehavior" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbMisbehavior_2" name="rbMisbehavior" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbMisbehavior_3" name="rbMisbehavior" type="radio" className='add-only' value="3" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>74. Sexually Reactive Behavior</td>
                        <td className='w-25'><input id="rbSexuallyReactive_0" name="rbSexuallyReactive" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSexuallyReactive_1" name="rbSexuallyReactive" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSexuallyReactive_2" name="rbSexuallyReactive" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSexuallyReactive_3" name="rbSexuallyReactive" type="radio" className='add-only' value="3" /></td>
                    </tr>
                </table> 
                <p className='w-750'>
                    <span className=' eleHeader'> RATINGS OF CHIDLREN 5 YEARS and YOUNGER - OPTIONAL DOMAIN</span>
                    <span className=' small'>
                        This domain is also meant for use developmentally delayed children of any age, and can be used with any
                        child/youth if these are areas of relevant needs regardless of child's age. </span>
                </p> 
                <table>
                    <tr>
                        <td className='w-375'></td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                        <td className='w-25'><b>NA</b></td>
                        <td className='w-25'><b>U</b></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>75.  Motor</td>
                        <td className='w-25'><input id="rbMotor_0" name="rbMotor" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbMotor_1" name="rbMotor" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbMotor_2" name="rbMotor" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbMotor_3" name="rbMotor" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbMotor_NA" name="rbMotor" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>76.  Sensory</td>
                        <td className='w-25'><input id="rbSensory_0" name="rbSensory" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSensory_1" name="rbSensory" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSensory_2" name="rbSensory" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSensory_3" name="rbSensory" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbSensory_NA" name="rbSensory" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>77.  Communication</td>
                        <td className='w-25'><input id="rbCommunication_0" name="rbCommunication" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCommunication_1" name="rbCommunication" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCommunication_2" name="rbCommunication" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCommunication_3" name="rbCommunication" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCommunication_NA" name="rbCommunication" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>78.  Failure to Thrive</td>
                        <td className='w-25'><input id="rbThrive_0" name="rbThrive" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbThrive_1" name="rbThrive" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbThrive_2" name="rbThrive" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbThrive_3" name="rbThrive" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbThrive_NA" name="rbThrive" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>79.  Feeding/Elimination</td>
                        <td className='w-25'><input id="rbElimination_0" name="rbElimination" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbElimination_1" name="rbElimination" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbElimination_2" name="rbElimination" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbElimination_3" name="rbElimination" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbElimination_NA" name="rbElimination" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>80.  Birth Weight</td>
                        <td className='w-25'><input id="rbBirthWeight_0" name="rbBirthWeight" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbBirthWeight_1" name="rbBirthWeight" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbBirthWeight_2" name="rbBirthWeight" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbBirthWeight_3" name="rbBirthWeight" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbBirthWeight_NA" name="rbBirthWeight" type="radio" className='add-only' value="NA" /></td>
                        <td className='w-25'><input id="rbBirthWeight_U" name="rbBirthWeight" type="radio" className='add-only' value="U" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>81.  Prenatal Care</td>
                        <td className='w-25'><input id="rbPrenatalCare_0" name="rbPrenatalCare" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbPrenatalCare_1" name="rbPrenatalCare" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbPrenatalCare_2" name="rbPrenatalCare" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbPrenatalCare_3" name="rbPrenatalCare" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbPrenatalCare_NA" name="rbPrenatalCare" type="radio" className='add-only' value="NA" /></td>
                        <td className='w-25'><input id="rbPrenatalCare_U" name="rbPrenatalCare" type="radio" className='add-only' value="U" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>82.  Substance Exposure</td>
                        <td className='w-25'><input id="rbExposure_0" name="rbExposure" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbExposure_1" name="rbExposure" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbExposure_2" name="rbExposure" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbExposure_3" name="rbExposure" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbExposure_NA" name="rbExposure" type="radio" className='add-only' value="NA" /></td>
                        <td className='w-25'><input id="rbExposure_U" name="rbExposure" type="radio" className='add-only' value="U" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>83.  Labor & Delivery</td>
                        <td className='w-25'><input id="rbDelivery_0" name="rbDelivery" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbDelivery_1" name="rbDelivery" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbDelivery_2" name="rbDelivery" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbDelivery_3" name="rbDelivery" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbDelivery_NA" name="rbDelivery" type="radio" className='add-only' value="NA" /></td>
                        <td className='w-25'><input id="rbDelivery_U" name="rbDelivery" type="radio" className='add-only' value="U" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>84.  Parent/Sibling Problems</td>
                        <td className='w-25'><input id="rbSiblingProblems_0" name="rbSiblingProblems" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbSiblingProblems_1" name="rbSiblingProblems" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbSiblingProblems_2" name="rbSiblingProblems" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbSiblingProblems_3" name="rbSiblingProblems" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbSiblingProblems_NA" name="rbSiblingProblems" type="radio" className='add-only' value="NA" /></td>
                        <td className='w-25'><input id="rbSiblingProblems_U" name="rbSiblingProblems" type="radio" className='add-only' value="U" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>85.  Availability of Caregiver</td>
                        <td className='w-25'><input id="rbAvailability_0" name="rbAvailability" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbAvailability_1" name="rbAvailability" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbAvailability_2" name="rbAvailability" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbAvailability_3" name="rbAvailability" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbAvailability_NA" name="rbAvailability" type="radio" className='add-only' value="NA" /></td>
                        <td className='w-25'><input id="rbAvailability_U" name="rbAvailability" type="radio" className='add-only' value="U" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>86.  Curiosity</td>
                        <td className='w-25'><input id="rbCuriosity_0" name="rbCuriosity" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCuriosity_1" name="rbCuriosity" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCuriosity_2" name="rbCuriosity" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCuriosity_3" name="rbCuriosity" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCuriosity_NA" name="rbCuriosity" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>87.  Playfulness</td>
                        <td className='w-25'><input id="rbPlayfulness_0" name="rbPlayfulness" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbPlayfulness_1" name="rbPlayfulness" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbPlayfulness_2" name="rbPlayfulness" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbPlayfulness_3" name="rbPlayfulness" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbPlayfulness_NA" name="rbPlayfulness" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>88.  Temperament</td>
                        <td className='w-25'><input id="rbTemperament_0" name="rbTemperament" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbTemperament_1" name="rbTemperament" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbTemperament_2" name="rbTemperament" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbTemperament_3" name="rbTemperament" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbTemperament_NA" name="rbTemperament" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>89.  Day Care Preschool</td>
                        <td className='w-25'><input id="rbPreschool_0" name="rbPreschool" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbPreschool_1" name="rbPreschool" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbPreschool_2" name="rbPreschool" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbPreschool_3" name="rbPreschool" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbPreschool_NA" name="rbPreschool" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className=' eleHeader'>TRANSITION TO ADULTHOOD - OPTIONAL DOMAIN </span>
                    <span className=' small'>This domain is meant primarily for youth 14 and YJ years or older, but can be used with any child/youth if these are
                        areas of relevant needs regardless of child's age. </span>
                </p>

                <table  >
                    <tr>
                        <td className='w-375'></td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                        <td className='w-25'><b>NA</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>90.  Independent Living Skills</td>
                        <td className='w-25'><input id="rbIndependent_0" name="rbIndependent" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbIndependent_1" name="rbIndependent" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbIndependent_2" name="rbIndependent" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbIndependent_3" name="rbIndependent" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbIndependent_NA" name="rbIndependent" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>91. Transportation</td>
                        <td className='w-25'><input id="rbTransportation_0" name="rbTransportation" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbTransportation_1" name="rbTransportation" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbTransportation_2" name="rbTransportation" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbTransportation_3" name="rbTransportation" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbTransportation_NA" name="rbTransportation" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>92. Parenting Roles</td>
                        <td className='w-25'><input id="rbParentingRoles_0" name="rbParentingRoles" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbParentingRoles_1" name="rbParentingRoles" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbParentingRoles_2" name="rbParentingRoles" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbParentingRoles_3" name="rbParentingRoles" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbParentingRoles_NA" name="rbParentingRoles" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>93. Intimate Relationships</td>
                        <td className='w-25'><input id="rbRelationships_0" name="rbRelationships" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbRelationships_1" name="rbRelationships" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbRelationships_2" name="rbRelationships" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbRelationships_3" name="rbRelationships" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbRelationships_NA" name="rbRelationships" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>94.  Medication Compliance</td>
                        <td className='w-25'><input id="rbMedication_0" name="rbMedication" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbMedication_1" name="rbMedication" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbMedication_2" name="rbMedication" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbMedication_3" name="rbMedication" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbMedication_NA" name="rbMedication" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>95.  Education Attainment</td>
                        <td className='w-25'><input id="rbEducationAttainment_0" name="rbEducationAttainment" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbEducationAttainment_1" name="rbEducationAttainment" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbEducationAttainment_2" name="rbEducationAttainment" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbEducationAttainment_3" name="rbEducationAttainment" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbEducationAttainment_NA" name="rbEducationAttainment" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>96.  Victimization</td>
                        <td className='w-25'><input id="rbVictimization_0" name="rbVictimization" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbVictimization_1" name="rbVictimization" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbVictimization_2" name="rbVictimization" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbVictimization_3" name="rbVictimization" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbVictimization_NA" name="rbVictimization" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>97. Job Functioning</td>
                        <td className='w-25'><input id="rbJobFunctioning_0" name="rbJobFunctioning" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbJobFunctioning_1" name="rbJobFunctioning" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbJobFunctioning_2" name="rbJobFunctioning" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbJobFunctioning_3" name="rbJobFunctioning" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbJobFunctioning_NA" name="rbJobFunctioning" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                </table> 
                <p className='w-750'>
                    <span className=' eleHeader'>CAREGIVER(S) NEEDS AND STRENGTHS </span>
                    <span className=' small'>Title/Role of Caregiver #1 (relation to child):  </span>
                </p> 
                <table>

                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                        <td className='w-25'><b>NA</b></td>
                    </tr>

                    <tr>
                        <td className='w-375'>98. Physical </td>
                        <td className='w-25'><input id="rbCaregiver1_Physical_0" name="rbCaregiver1_Physical" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Physical_1" name="rbCaregiver1_Physical" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Physical_2" name="rbCaregiver1_Physical" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Physical_3" name="rbCaregiver1_Physical" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Physical_NA" name="rbCaregiver1_Physical" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>99. Mental Health</td>
                        <td className='w-25'><input id="rbCaregiver1_MentalHealth_0" name="rbCaregiver1_MentalHealth" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_MentalHealth_1" name="rbCaregiver1_MentalHealth" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_MentalHealth_2" name="rbCaregiver1_MentalHealth" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_MentalHealth_3" name="rbCaregiver1_MentalHealth" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_MentalHealth_NA" name="rbCaregiver1_MentalHealth" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>100.  Substance Use</td>
                        <td className='w-25'><input id="rbCaregiver1_Substance_0" name="rbCaregiver1_Substance" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Substance_1" name="rbCaregiver1_Substance" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Substance_2" name="rbCaregiver1_Substance" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Substance_3" name="rbCaregiver1_Substance" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Substance_NA" name="rbCaregiver1_Substance" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>101.  Developmental</td>
                        <td className='w-25'><input id="rbCaregiver1_Developmental_0" name="rbCaregiver1_Developmental" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Developmental_1" name="rbCaregiver1_Developmental" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Developmental_2" name="rbCaregiver1_Developmental" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Developmental_3" name="rbCaregiver1_Developmental" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Developmental_NA" name="rbCaregiver1_Developmental" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>102.  Supervision</td>
                        <td className='w-25'><input id="rbCaregiver1_Supervision_0" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Supervision_1" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Supervision_2" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Supervision_3" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Supervision_NA" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>103. Involvement </td>
                        <td className='w-25'><input id="rbCaregiver1_Involvement_0" name="rbCaregiver1_Involvement" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Involvement_1" name="rbCaregiver1_Involvement" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Involvement_2" name="rbCaregiver1_Involvement" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Involvement_3" name="rbCaregiver1_Involvement" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Involvement_NA" name="rbCaregiver1_Involvement" type="radio" className='add-only' value="NA" /></td>
                    </tr>




                    <tr>
                        <td className='w-375'>104. Knowledge</td>
                        <td className='w-25'><input id="rbCaregiver1_Knowledge_0" name="rbCaregiver1_Knowledge" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Knowledge_1" name="rbCaregiver1_Knowledge" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Knowledge_2" name="rbCaregiver1_Knowledge" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Knowledge_3" name="rbCaregiver1_Knowledge" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Knowledge_NA" name="rbCaregiver1_Knowledge" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>105.  Organization</td>
                        <td className='w-25'><input id="rbCaregiver1_Organization_0" name="rbCaregiver1_Organization" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Organization_1" name="rbCaregiver1_Organization" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Organization_2" name="rbCaregiver1_Organization" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Organization_3" name="rbCaregiver1_Organization" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Organization_NA" name="rbCaregiver1_Organization" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>106. Resources</td>
                        <td className='w-25'><input id="rbCaregiver1_Resources_0" name="rbCaregiver1_Resources" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Resources_1" name="rbCaregiver1_Resources" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Resources_2" name="rbCaregiver1_Resources" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Resources_3" name="rbCaregiver1_Resources" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Resources_NA" name="rbCaregiver1_Resources" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>107. Residential Stability</td>
                        <td className='w-25'><input id="rbCaregiver1_Residential_0" name="rbCaregiver1_Residential" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Residential_1" name="rbCaregiver1_Residential" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Residential_2" name="rbCaregiver1_Residential" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Residential_3" name="rbCaregiver1_Residential" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Residential_NA" name="rbCaregiver1_Residential" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>108. Safety</td>
                        <td className='w-25'><input id="rbCaregiver1_Safety_0" name="rbCaregiver1_Safety" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Safety_1" name="rbCaregiver1_Safety" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Safety_2" name="rbCaregiver1_Safety" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Safety_3" name="rbCaregiver1_Safety" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Safety_NA" name="rbCaregiver1_Safety" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>109.  Marital/Partner Violence</td>
                        <td className='w-25'><input id="rbCaregiver1_PartnerViolence_0" name="rbCaregiver1_PartnerViolence" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_PartnerViolence_1" name="rbCaregiver1_PartnerViolence" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_PartnerViolence_2" name="rbCaregiver1_PartnerViolence" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_PartnerViolence_3" name="rbCaregiver1_PartnerViolence" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_PartnerViolence_NA" name="rbCaregiver1_PartnerViolence" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>110.   Posttraumatic Reactions </td>
                        <td className='w-25'><input id="rbCaregiver1_Reactions_0" name="rbCaregiver1_Reactions" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Reactions_1" name="rbCaregiver1_Reactions" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Reactions_2" name="rbCaregiver1_Reactions" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Reactions_3" name="rbCaregiver1_Reactions" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver1_Reactions_NA" name="rbCaregiver1_Reactions" type="radio" className='add-only' value="NA" /></td>
                    </tr> 
                </table> 
                <p className='w-750'>
                    <span className=' eleHeader'>CAREGIVER(S) NEEDS AND STRENGTHS </span>
                    <span className=' small'>Title/Role of Caregiver #2 (relation to child):  </span>
                </p> 
                <table> 
                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-25'><b>0</b></td>
                        <td className='w-25'><b>1</b></td>
                        <td className='w-25'><b>2</b></td>
                        <td className='w-25'><b>3</b></td>
                        <td className='w-25'><b>NA</b></td>
                    </tr>

                    <tr>
                        <td className='w-375'>98. Physical </td>
                        <td className='w-25'><input id="rbCaregiver2_Physical_0" name="rbCaregiver2_Physical" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Physical_1" name="rbCaregiver2_Physical" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Physical_2" name="rbCaregiver2_Physical" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Physical_3" name="rbCaregiver2_Physical" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Physical_NA" name="rbCaregiver2_Physical" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>99. Mental Health</td>
                        <td className='w-25'><input id="rbCaregiver2_MentalHealth_0" name="rbCaregiver2_MentalHealth" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_MentalHealth_1" name="rbCaregiver2_MentalHealth" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_MentalHealth_2" name="rbCaregiver2_MentalHealth" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_MentalHealth_3" name="rbCaregiver2_MentalHealth" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_MentalHealth_NA" name="rbCaregiver2_MentalHealth" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>100.  Substance Use</td>
                        <td className='w-25'><input id="rbCaregiver2_Substance_0" name="rbCaregiver2_Substance" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Substance_1" name="rbCaregiver2_Substance" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Substance_2" name="rbCaregiver2_Substance" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Substance_3" name="rbCaregiver2_Substance" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Substance_NA" name="rbCaregiver2_Substance" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>101.  Developmental</td>
                        <td className='w-25'><input id="rbCaregiver2_Developmental_0" name="rbCaregiver2_Developmental" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Developmental_1" name="rbCaregiver2_Developmental" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Developmental_2" name="rbCaregiver2_Developmental" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Developmental_3" name="rbCaregiver2_Developmental" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Developmental_NA" name="rbCaregiver2_Developmental" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>102.  Supervision</td>
                        <td className='w-25'><input id="rbCaregiver2_Supervision_0" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Supervision_1" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Supervision_2" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Supervision_3" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Supervision_NA" name="rbCaregiver1_Supervision" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>103. Involvement </td>
                        <td className='w-25'><input id="rbCaregiver2_Involvement_0" name="rbCaregiver2_Involvement" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Involvement_1" name="rbCaregiver2_Involvement" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Involvement_2" name="rbCaregiver2_Involvement" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Involvement_3" name="rbCaregiver2_Involvement" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Involvement_NA" name="rbCaregiver2_Involvement" type="radio" className='add-only' value="NA" /></td>
                    </tr> 
                    <tr>
                        <td className='w-375'>104. Knowledge</td>
                        <td className='w-25'><input id="rbCaregiver2_Knowledge_0" name="rbCaregiver2_Knowledge" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Knowledge_1" name="rbCaregiver2_Knowledge" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Knowledge_2" name="rbCaregiver2_Knowledge" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Knowledge_3" name="rbCaregiver2_Knowledge" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Knowledge_NA" name="rbCaregiver2_Knowledge" type="radio" className='add-only' value="NA" /></td>
                    </tr>
                    <tr  >
                        <td className='w-375'>105.  Organization</td>
                        <td className='w-25'><input id="rbCaregiver2_Organization_0" name="rbCaregiver2_Organization" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Organization_1" name="rbCaregiver2_Organization" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Organization_2" name="rbCaregiver2_Organization" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Organization_3" name="rbCaregiver2_Organization" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Organization_NA" name="rbCaregiver2_Organization" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>106. Resources</td>
                        <td className='w-25'><input id="rbCaregiver2_Resources_0" name="rbCaregiver2_Resources" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Resources_1" name="rbCaregiver2_Resources" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Resources_2" name="rbCaregiver2_Resources" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Resources_3" name="rbCaregiver2_Resources" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Resources_NA" name="rbCaregiver2_Resources" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>107. Residential Stability</td>
                        <td className='w-25'><input id="rbCaregiver2_Residential_0" name="rbCaregiver2_Residential" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Residential_1" name="rbCaregiver2_Residential" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Residential_2" name="rbCaregiver2_Residential" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Residential_3" name="rbCaregiver2_Residential" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Residential_NA" name="rbCaregiver2_Residential" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>108. Safety</td>
                        <td className='w-25'><input id="rbCaregiver2_Safety_0" name="rbCaregiver2_Safety" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Safety_1" name="rbCaregiver2_Safety" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Safety_2" name="rbCaregiver2_Safety" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Safety_3" name="rbCaregiver2_Safety" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Safety_NA" name="rbCaregiver2_Safety" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr  >
                        <td className='w-375'>109.  Marital/Partner Violence</td>
                        <td className='w-25'><input id="rbCaregiver2_PartnerViolence_0" name="rbCaregiver2_PartnerViolence" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_PartnerViolence_1" name="rbCaregiver2_PartnerViolence" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_PartnerViolence_2" name="rbCaregiver2_PartnerViolence" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_PartnerViolence_3" name="rbCaregiver2_PartnerViolence" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_PartnerViolence_NA" name="rbCaregiver2_PartnerViolence" type="radio" className='add-only' value="NA" /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>110.   Posttraumatic Reactions </td>
                        <td className='w-25'><input id="rbCaregiver2_Reactions_0" name="rbCaregiver2_Reactions" type="radio" className='add-only' value="0" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Reactions_1" name="rbCaregiver2_Reactions" type="radio" className='add-only' value="1" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Reactions_2" name="rbCaregiver2_Reactions" type="radio" className='add-only' value="2" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Reactions_3" name="rbCaregiver2_Reactions" type="radio" className='add-only' value="3" /></td>
                        <td className='w-25'><input id="rbCaregiver2_Reactions_NA" name="rbCaregiver2_Reactions" type="radio" className='add-only' value="NA" /></td>
                    </tr> 
                </table>
                <h3>Y.	RECOMMENDED SERVICES </h3>
            <span className='small'>(select all that apply):</span>
               <p className="w-750">
                  <input type="checkbox" id="cbRecommendedServices_1" name="cbRecommendedServices_1" className='add-only' value="RecommendedServices_1" />Individual Therapy (90832, 90834, 90837) <br />
                  <input type="checkbox" id="cbRecommendedServices_2" name="cbRecommendedServices_2" className='add-only' value="RecommendedServices_2" />Family Therapy (90846, 90847, H0004) <br />
                  <input type="checkbox" id="cbRecommendedServices_3" name="cbRecommendedServices_3" className='add-only' value="RecommendedServices_3" />PP Community Support Individual (H2015) <br />
                  <input type="checkbox" id="cbRecommendedServices_4" name="cbRecommendedServices_4" className='add-only' value="RecommendedServices_4" />PP Family Skills Training (H2014) <br />
                  <input type="checkbox" id="cbRecommendedServices_5" name="cbRecommendedServices_5" className='add-only' value="RecommendedServices_5" /> Medication Management <br />
                  <input type="checkbox" id="cbRecommendedServices_6" name="cbRecommendedServices_6" className='add-only' value="RecommendedServices_6" />Intensive Family Intervention (IFI)
                  <p className="w-750">  <strong>i. Upon the completion of the Assessment, if IFI services are recommended, please inform the Clinical Director.  </strong> <br />
                                        <strong>ii. Behaviors to consider when referring to IFI:</strong>
                   </p>
                       <ol>
                        <li>Frequent hospitalizations</li>
                        <li>History SI/HI/Self-Harming</li>
                        <li>History or current legal involvement (within the past 180 days)</li>
                        <li>History or current school suspensions</li>
                        <li>Behaviors that may require services to be rendered more than 3 days per week</li>
                       </ol>
                </p> 
              <h3>COMPLETED BY:</h3>
              <h4>TRANSITION /DISCHARGE PLAN</h4>
              <p className="w-750">
              <span className='small'><strong> (Step down service should be a non-CORE related service [i.e., Med Mgmt., Support Group, Mentoring Program etc.] 
                  Must be written in S.M.A.R.T format</strong></span>
              </p>
              <table>
              <tr>
                    <td className='w-375'><span className='eleHeader'>Projected Date of Discharge/Transition: </span></td>
                    <td className='w-375'><span className='eleHeader'>Anticipated Step Down Service:  </span></td>
                        
                </tr>
                <tr>
                    <td className='w-375'><input type="date" id="txtTRANSITION_DISCHARGE_1" name="txtTRANSITION_DISCHARGE_1" className='add-only' /></td>
                    <td className='w-375'><input type="text" id="txtTRANSITION_DISCHARGE_2" name="txtTRANSITION_DISCHARGE_2" className='add-only' /></td>
                    </tr>
              </table>
              <p className="w-750">
                 <span className='eleHeader'>Plans for Transition/Discharge:   </span>
                 <textarea id="txtTRANSITION_DISCHARGE_3" name="txtTRANSITION_DISCHARGE_3" className='add-only'></textarea>
              </p>
                        
                   
                    
                    
              <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Assessor Signature:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Assessor Print Name:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                </table>
                <h3>REVIEWED BY </h3>
                <span className='small'>(If Applicable):</span>
                <p className='w-750'>
                    <span className='small'>(Please include credentials after your name)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Licensed Professional Signature:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Licensed Professional Print Name:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                </table>
            </div>
        </form>
   )
}


              
            
                    
            
            
            
            
            
            
            
            
                
                
                    
        

                   




                  
                  
                
                        
                        
                        
                    























